"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CMC Markets Developer Portal
 * ### Invoke API using this Dev Portal    * Open `API Servers` and select the API Server to be used    * Open `Authentication`, select `Request Body` instead of *Authorization Header* and `Get Token` to fetch a JWT token    * Invoke the function  ### Generate Client Code  ```docker run --rm -v ${PWD}:/local openapitools/openapi-generator-cli generate -i https://api-signup.invest.cmcmarkets.com.au/developer/swagger.json -g typescript-fetch -o /local/ts```
 *
 * The version of the OpenAPI document: 1.4.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationApiAxiosParamCreator = exports.AddressApi = exports.AddressApiFactory = exports.AddressApiFp = exports.AddressApiAxiosParamCreator = exports.WfeLoginApiResultState = exports.WfeForgotPasswordSubmitResultState = exports.VerificationOutcome1 = exports.VerificationOutcome = exports.ValidationOutcome1 = exports.ValidationOutcome = exports.UsersErrorCode = exports.TradingState = exports.TaxResidentType = exports.SymbolRefreshInterval = exports.StatusTypeEnum = exports.State = exports.ServiceProviderTypeEnum = exports.SecurityCategory = exports.ProcessErrorCodeEnum = exports.OutcomeTypeEnum = exports.OptionsMoneyStatus = exports.MedicareCardColourType = exports.MedicareCardColour = exports.MarketdataSubscribeQuoteV1IntervalEnum = exports.MarketdataSubscribeQuoteV1ActionEnum = exports.MarketdataSubscribeDepthV1ActionEnum = exports.MarketdataSubscribeCourseOfSaleV1ActionEnum = exports.MarketdataSubscribeChartV1EndEnum = exports.MarketdataSubscribeChartV1StartEnum = exports.MarketdataSubscribeChartV1IntervalEnum = exports.MarketdataSubscribeChartV1ActionEnum = exports.MarketdataErrorCode = exports.LatestApplicationIdErrorCode = exports.IdentificationType = exports.GetVerifyIdentityErrorCode = exports.FraudOutcome = exports.FraudAssessmentFactorType = exports.ExchangeId = exports.DeliveryMedium = exports.CreateSubscriptionsErrorCode = exports.CountryCode = exports.CashAccountDetailsErrorCode = exports.Brand = exports.ApplicationSubmitErrorCode = exports.ApplicationStatusErrorCode = exports.ApplicationBadRequestErrorCode = exports.AddressErrorCode = exports.AccountType = exports.AccountApplicationProgress = void 0;
exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = exports.TradingAccountApi = exports.TradingAccountApiFactory = exports.TradingAccountApiFp = exports.TradingAccountApiAxiosParamCreator = exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiAxiosParamCreator = exports.PrivateApi = exports.PrivateApiFactory = exports.PrivateApiFp = exports.PrivateApiAxiosParamCreator = exports.MarketdataApi = exports.MarketdataApiFactory = exports.MarketdataApiFp = exports.MarketdataApiAxiosParamCreator = exports.IdentityInternationalApi = exports.IdentityInternationalApiFactory = exports.IdentityInternationalApiFp = exports.IdentityInternationalApiAxiosParamCreator = exports.IdentityApi = exports.IdentityApiFactory = exports.IdentityApiFp = exports.IdentityApiAxiosParamCreator = exports.DeveloperApi = exports.DeveloperApiFactory = exports.DeveloperApiFp = exports.DeveloperApiAxiosParamCreator = exports.ApplicationApi = exports.ApplicationApiFactory = exports.ApplicationApiFp = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var AccountApplicationProgress;
(function (AccountApplicationProgress) {
    AccountApplicationProgress["Finalise"] = "Finalise";
    AccountApplicationProgress["IdVerified"] = "IdVerified";
    AccountApplicationProgress["GbstAccountCreated"] = "GbstAccountCreated";
    AccountApplicationProgress["TradingAccountCreated"] = "TradingAccountCreated";
    AccountApplicationProgress["WorldCheckComplete"] = "WorldCheckComplete";
    AccountApplicationProgress["FraudulentDataCheck"] = "FraudulentDataCheck";
    AccountApplicationProgress["CashAccountCreated"] = "CashAccountCreated";
    AccountApplicationProgress["Completed"] = "Completed";
    AccountApplicationProgress["ReadyToTrade"] = "ReadyToTrade";
})(AccountApplicationProgress = exports.AccountApplicationProgress || (exports.AccountApplicationProgress = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AccountType;
(function (AccountType) {
    AccountType["Individual"] = "Individual";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var AddressErrorCode;
(function (AddressErrorCode) {
    AddressErrorCode["InternalError"] = "InternalError";
    AddressErrorCode["MissingInput"] = "MissingInput";
    AddressErrorCode["AddressSearchFail"] = "AddressSearchFail";
    AddressErrorCode["AddressFormatFail"] = "AddressFormatFail";
})(AddressErrorCode = exports.AddressErrorCode || (exports.AddressErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationBadRequestErrorCode;
(function (ApplicationBadRequestErrorCode) {
    ApplicationBadRequestErrorCode["EmptyRequest"] = "EmptyRequest";
    ApplicationBadRequestErrorCode["ClientIpAddressRequired"] = "ClientIpAddressRequired";
    ApplicationBadRequestErrorCode["ReferringSiteRequired"] = "ReferringSiteRequired";
    ApplicationBadRequestErrorCode["AccountTypeMustBeIndividual"] = "AccountTypeMustBeIndividual";
    ApplicationBadRequestErrorCode["EmailRequired"] = "EmailRequired";
    ApplicationBadRequestErrorCode["MobileRequired"] = "MobileRequired";
    ApplicationBadRequestErrorCode["ProfileRequired"] = "ProfileRequired";
    ApplicationBadRequestErrorCode["IdentityRequired"] = "IdentityRequired";
    ApplicationBadRequestErrorCode["TermsAndConditionsRequired"] = "TermsAndConditionsRequired";
    ApplicationBadRequestErrorCode["ProfileAddressRequired"] = "ProfileAddressRequired";
    ApplicationBadRequestErrorCode["ProfileOccupationRequired"] = "ProfileOccupationRequired";
    ApplicationBadRequestErrorCode["ProfilePersonalDetailsRequired"] = "ProfilePersonalDetailsRequired";
    ApplicationBadRequestErrorCode["ProfileTaxDetailsRequired"] = "ProfileTaxDetailsRequired";
    ApplicationBadRequestErrorCode["ProfileResidentialAddressRequired"] = "ProfileResidentialAddressRequired";
    ApplicationBadRequestErrorCode["ProfileResidentialAddressInvalid"] = "ProfileResidentialAddressInvalid";
    ApplicationBadRequestErrorCode["ProfilePostalAddressRequired"] = "ProfilePostalAddressRequired";
    ApplicationBadRequestErrorCode["ProfilePostalAddressInvalid"] = "ProfilePostalAddressInvalid";
    ApplicationBadRequestErrorCode["ProfileTitleRequired"] = "ProfileTitleRequired";
    ApplicationBadRequestErrorCode["ProfileFirstNameRequired"] = "ProfileFirstNameRequired";
    ApplicationBadRequestErrorCode["ProfileLastNameRequired"] = "ProfileLastNameRequired";
    ApplicationBadRequestErrorCode["ProfileDobRequired"] = "ProfileDobRequired";
    ApplicationBadRequestErrorCode["ProfileTaxResidentTypeRequired"] = "ProfileTaxResidentTypeRequired";
    ApplicationBadRequestErrorCode["ProfileAustralianTfnInvalid"] = "ProfileAustralianTfnInvalid";
    ApplicationBadRequestErrorCode["ProfileOverseaTaxInfoRequired"] = "ProfileOverseaTaxInfoRequired";
    ApplicationBadRequestErrorCode["IdentityDriversLicenceIncomplete"] = "IdentityDriversLicenceIncomplete";
    ApplicationBadRequestErrorCode["IdentityPassportIncomplete"] = "IdentityPassportIncomplete";
    ApplicationBadRequestErrorCode["IdentityMedicareIncomplete"] = "IdentityMedicareIncomplete";
    ApplicationBadRequestErrorCode["InvalidParameter"] = "InvalidParameter";
    ApplicationBadRequestErrorCode["UserIdChanged"] = "UserIdChanged";
    ApplicationBadRequestErrorCode["NoUserRecordFound"] = "NoUserRecordFound";
    ApplicationBadRequestErrorCode["InvalidCriminalOffence"] = "InvalidCriminalOffence";
    ApplicationBadRequestErrorCode["InvalidLivedOtherCountry"] = "InvalidLivedOtherCountry";
    ApplicationBadRequestErrorCode["InvalidOtherCitizenship"] = "InvalidOtherCitizenship";
    ApplicationBadRequestErrorCode["InvalidPenalisedByGovernmentRegulator"] = "InvalidPenalisedByGovernmentRegulator";
    ApplicationBadRequestErrorCode["InvalidSeniorGovermentRole"] = "InvalidSeniorGovermentRole";
    ApplicationBadRequestErrorCode["InvalidOtherName"] = "InvalidOtherName";
    ApplicationBadRequestErrorCode["InvalidPepEvent"] = "InvalidPepEvent";
    ApplicationBadRequestErrorCode["InvalidCityName"] = "InvalidCityName";
    ApplicationBadRequestErrorCode["InvalidCountry"] = "InvalidCountry";
    ApplicationBadRequestErrorCode["InvalidMonth"] = "InvalidMonth";
    ApplicationBadRequestErrorCode["InvalidYear"] = "InvalidYear";
    ApplicationBadRequestErrorCode["InvalidDate"] = "InvalidDate";
})(ApplicationBadRequestErrorCode = exports.ApplicationBadRequestErrorCode || (exports.ApplicationBadRequestErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationStatusErrorCode;
(function (ApplicationStatusErrorCode) {
    ApplicationStatusErrorCode["InvalidParameter"] = "InvalidParameter";
    ApplicationStatusErrorCode["ApplicationNotExists"] = "ApplicationNotExists";
})(ApplicationStatusErrorCode = exports.ApplicationStatusErrorCode || (exports.ApplicationStatusErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ApplicationSubmitErrorCode;
(function (ApplicationSubmitErrorCode) {
    ApplicationSubmitErrorCode["NoResponse"] = "NoResponse";
    ApplicationSubmitErrorCode["SubmitFailure"] = "SubmitFailure";
    ApplicationSubmitErrorCode["PartnerNotSupport"] = "PartnerNotSupport";
    ApplicationSubmitErrorCode["ClientNotExists"] = "ClientNotExists";
    ApplicationSubmitErrorCode["MissingIdToken"] = "MissingIdToken";
    ApplicationSubmitErrorCode["IdTokenError"] = "IdTokenError";
    ApplicationSubmitErrorCode["SetClientActiveFailure"] = "SetClientActiveFailure";
    ApplicationSubmitErrorCode["LinkedFail"] = "LinkedFail";
})(ApplicationSubmitErrorCode = exports.ApplicationSubmitErrorCode || (exports.ApplicationSubmitErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Brand;
(function (Brand) {
    Brand["cmc"] = "cmc";
    Brand["cmcinvestsingapore"] = "cmcinvestsingapore";
    Brand["advantage"] = "advantage";
    Brand["anz"] = "anz";
    Brand["bendigo"] = "bendigo";
    Brand["boq"] = "boq";
    Brand["cmcinvestalpha"] = "cmcinvestalpha";
    Brand["collateraliseportal"] = "collateraliseportal";
    Brand["ebroking"] = "ebroking";
    Brand["mola"] = "mola";
    Brand["rivkin"] = "rivkin";
    Brand["stgeorge"] = "stgeorge";
    Brand["suncorp"] = "suncorp";
    Brand["supervision"] = "supervision";
})(Brand = exports.Brand || (exports.Brand = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CashAccountDetailsErrorCode;
(function (CashAccountDetailsErrorCode) {
    CashAccountDetailsErrorCode["InvalidParameter"] = "InvalidParameter";
    CashAccountDetailsErrorCode["ApplicationNotExists"] = "ApplicationNotExists";
    CashAccountDetailsErrorCode["CashAccountHasNotCreated"] = "CashAccountHasNotCreated";
    CashAccountDetailsErrorCode["CashAccountNotExists"] = "CashAccountNotExists";
    CashAccountDetailsErrorCode["CashAccountNameMissing"] = "CashAccountNameMissing";
    CashAccountDetailsErrorCode["CashAccountBsbMissing"] = "CashAccountBsbMissing";
    CashAccountDetailsErrorCode["CashAccountNumberMissing"] = "CashAccountNumberMissing";
})(CashAccountDetailsErrorCode = exports.CashAccountDetailsErrorCode || (exports.CashAccountDetailsErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CountryCode;
(function (CountryCode) {
    CountryCode["ABW"] = "ABW";
    CountryCode["AFG"] = "AFG";
    CountryCode["AGO"] = "AGO";
    CountryCode["AIA"] = "AIA";
    CountryCode["ALA"] = "ALA";
    CountryCode["ALB"] = "ALB";
    CountryCode["AND"] = "AND";
    CountryCode["ANT"] = "ANT";
    CountryCode["ARE"] = "ARE";
    CountryCode["ARG"] = "ARG";
    CountryCode["ARM"] = "ARM";
    CountryCode["ASM"] = "ASM";
    CountryCode["ATA"] = "ATA";
    CountryCode["ATF"] = "ATF";
    CountryCode["ATG"] = "ATG";
    CountryCode["AUS"] = "AUS";
    CountryCode["AUT"] = "AUT";
    CountryCode["AZE"] = "AZE";
    CountryCode["BDI"] = "BDI";
    CountryCode["BEL"] = "BEL";
    CountryCode["BEN"] = "BEN";
    CountryCode["BFA"] = "BFA";
    CountryCode["BGD"] = "BGD";
    CountryCode["BGR"] = "BGR";
    CountryCode["BHR"] = "BHR";
    CountryCode["BHS"] = "BHS";
    CountryCode["BIH"] = "BIH";
    CountryCode["BLM"] = "BLM";
    CountryCode["BLR"] = "BLR";
    CountryCode["BLZ"] = "BLZ";
    CountryCode["BMU"] = "BMU";
    CountryCode["BOL"] = "BOL";
    CountryCode["BRA"] = "BRA";
    CountryCode["BRB"] = "BRB";
    CountryCode["BRN"] = "BRN";
    CountryCode["BTN"] = "BTN";
    CountryCode["BVT"] = "BVT";
    CountryCode["BWA"] = "BWA";
    CountryCode["CAF"] = "CAF";
    CountryCode["CAN"] = "CAN";
    CountryCode["CCK"] = "CCK";
    CountryCode["CHE"] = "CHE";
    CountryCode["CHL"] = "CHL";
    CountryCode["CHN"] = "CHN";
    CountryCode["CIV"] = "CIV";
    CountryCode["CMR"] = "CMR";
    CountryCode["COD"] = "COD";
    CountryCode["COG"] = "COG";
    CountryCode["COK"] = "COK";
    CountryCode["COL"] = "COL";
    CountryCode["COM"] = "COM";
    CountryCode["CPV"] = "CPV";
    CountryCode["CRI"] = "CRI";
    CountryCode["CUB"] = "CUB";
    CountryCode["CXR"] = "CXR";
    CountryCode["CYM"] = "CYM";
    CountryCode["CYP"] = "CYP";
    CountryCode["CZE"] = "CZE";
    CountryCode["DEU"] = "DEU";
    CountryCode["DJI"] = "DJI";
    CountryCode["DMA"] = "DMA";
    CountryCode["DNK"] = "DNK";
    CountryCode["DOM"] = "DOM";
    CountryCode["DZA"] = "DZA";
    CountryCode["ECU"] = "ECU";
    CountryCode["EGY"] = "EGY";
    CountryCode["ERI"] = "ERI";
    CountryCode["ESH"] = "ESH";
    CountryCode["ESP"] = "ESP";
    CountryCode["EST"] = "EST";
    CountryCode["ETH"] = "ETH";
    CountryCode["FIN"] = "FIN";
    CountryCode["FJI"] = "FJI";
    CountryCode["FLK"] = "FLK";
    CountryCode["FRA"] = "FRA";
    CountryCode["FRO"] = "FRO";
    CountryCode["FSM"] = "FSM";
    CountryCode["GAB"] = "GAB";
    CountryCode["GBR"] = "GBR";
    CountryCode["GEO"] = "GEO";
    CountryCode["GGY"] = "GGY";
    CountryCode["GHA"] = "GHA";
    CountryCode["GIB"] = "GIB";
    CountryCode["GIN"] = "GIN";
    CountryCode["GLP"] = "GLP";
    CountryCode["GMB"] = "GMB";
    CountryCode["GNB"] = "GNB";
    CountryCode["GNQ"] = "GNQ";
    CountryCode["GRC"] = "GRC";
    CountryCode["GRD"] = "GRD";
    CountryCode["GRL"] = "GRL";
    CountryCode["GTM"] = "GTM";
    CountryCode["GUF"] = "GUF";
    CountryCode["GUM"] = "GUM";
    CountryCode["GUY"] = "GUY";
    CountryCode["HKG"] = "HKG";
    CountryCode["HMD"] = "HMD";
    CountryCode["HND"] = "HND";
    CountryCode["HRV"] = "HRV";
    CountryCode["HTI"] = "HTI";
    CountryCode["HUN"] = "HUN";
    CountryCode["IDN"] = "IDN";
    CountryCode["IMN"] = "IMN";
    CountryCode["IND"] = "IND";
    CountryCode["IOT"] = "IOT";
    CountryCode["IRL"] = "IRL";
    CountryCode["IRN"] = "IRN";
    CountryCode["IRQ"] = "IRQ";
    CountryCode["ISL"] = "ISL";
    CountryCode["ISR"] = "ISR";
    CountryCode["ITA"] = "ITA";
    CountryCode["JAM"] = "JAM";
    CountryCode["JEY"] = "JEY";
    CountryCode["JOR"] = "JOR";
    CountryCode["JPN"] = "JPN";
    CountryCode["KAZ"] = "KAZ";
    CountryCode["KEN"] = "KEN";
    CountryCode["KGZ"] = "KGZ";
    CountryCode["KHM"] = "KHM";
    CountryCode["KIR"] = "KIR";
    CountryCode["KNA"] = "KNA";
    CountryCode["KOR"] = "KOR";
    CountryCode["KWT"] = "KWT";
    CountryCode["LAO"] = "LAO";
    CountryCode["LBN"] = "LBN";
    CountryCode["LBR"] = "LBR";
    CountryCode["LBY"] = "LBY";
    CountryCode["LCA"] = "LCA";
    CountryCode["LIE"] = "LIE";
    CountryCode["LKA"] = "LKA";
    CountryCode["LSO"] = "LSO";
    CountryCode["LTU"] = "LTU";
    CountryCode["LUX"] = "LUX";
    CountryCode["LVA"] = "LVA";
    CountryCode["MAC"] = "MAC";
    CountryCode["MAF"] = "MAF";
    CountryCode["MAR"] = "MAR";
    CountryCode["MCO"] = "MCO";
    CountryCode["MDA"] = "MDA";
    CountryCode["MDG"] = "MDG";
    CountryCode["MDV"] = "MDV";
    CountryCode["MEX"] = "MEX";
    CountryCode["MHL"] = "MHL";
    CountryCode["MKD"] = "MKD";
    CountryCode["MLI"] = "MLI";
    CountryCode["MLT"] = "MLT";
    CountryCode["MMR"] = "MMR";
    CountryCode["MNE"] = "MNE";
    CountryCode["MNG"] = "MNG";
    CountryCode["MNP"] = "MNP";
    CountryCode["MOZ"] = "MOZ";
    CountryCode["MRT"] = "MRT";
    CountryCode["MSR"] = "MSR";
    CountryCode["MTQ"] = "MTQ";
    CountryCode["MUS"] = "MUS";
    CountryCode["MWI"] = "MWI";
    CountryCode["MYS"] = "MYS";
    CountryCode["MYT"] = "MYT";
    CountryCode["NAM"] = "NAM";
    CountryCode["NCL"] = "NCL";
    CountryCode["NER"] = "NER";
    CountryCode["NFK"] = "NFK";
    CountryCode["NGA"] = "NGA";
    CountryCode["NIC"] = "NIC";
    CountryCode["NIU"] = "NIU";
    CountryCode["NLD"] = "NLD";
    CountryCode["NOR"] = "NOR";
    CountryCode["NPL"] = "NPL";
    CountryCode["NRU"] = "NRU";
    CountryCode["NZL"] = "NZL";
    CountryCode["OMN"] = "OMN";
    CountryCode["PAK"] = "PAK";
    CountryCode["PAN"] = "PAN";
    CountryCode["PCN"] = "PCN";
    CountryCode["PER"] = "PER";
    CountryCode["PHL"] = "PHL";
    CountryCode["PLW"] = "PLW";
    CountryCode["PNG"] = "PNG";
    CountryCode["POL"] = "POL";
    CountryCode["PRI"] = "PRI";
    CountryCode["PRK"] = "PRK";
    CountryCode["PRT"] = "PRT";
    CountryCode["PRY"] = "PRY";
    CountryCode["PSE"] = "PSE";
    CountryCode["PYF"] = "PYF";
    CountryCode["QAT"] = "QAT";
    CountryCode["REU"] = "REU";
    CountryCode["ROU"] = "ROU";
    CountryCode["RUS"] = "RUS";
    CountryCode["RWA"] = "RWA";
    CountryCode["SAU"] = "SAU";
    CountryCode["SDN"] = "SDN";
    CountryCode["SEN"] = "SEN";
    CountryCode["SGP"] = "SGP";
    CountryCode["SGS"] = "SGS";
    CountryCode["SHN"] = "SHN";
    CountryCode["SJM"] = "SJM";
    CountryCode["SLB"] = "SLB";
    CountryCode["SLE"] = "SLE";
    CountryCode["SLV"] = "SLV";
    CountryCode["SMR"] = "SMR";
    CountryCode["SOM"] = "SOM";
    CountryCode["SPM"] = "SPM";
    CountryCode["SRB"] = "SRB";
    CountryCode["SSD"] = "SSD";
    CountryCode["STP"] = "STP";
    CountryCode["SUR"] = "SUR";
    CountryCode["SVK"] = "SVK";
    CountryCode["SVN"] = "SVN";
    CountryCode["SWE"] = "SWE";
    CountryCode["SWZ"] = "SWZ";
    CountryCode["SXM"] = "SXM";
    CountryCode["SYC"] = "SYC";
    CountryCode["SYR"] = "SYR";
    CountryCode["TCA"] = "TCA";
    CountryCode["TCD"] = "TCD";
    CountryCode["TGO"] = "TGO";
    CountryCode["THA"] = "THA";
    CountryCode["TJK"] = "TJK";
    CountryCode["TKL"] = "TKL";
    CountryCode["TKM"] = "TKM";
    CountryCode["TLS"] = "TLS";
    CountryCode["TON"] = "TON";
    CountryCode["TTO"] = "TTO";
    CountryCode["TUN"] = "TUN";
    CountryCode["TUR"] = "TUR";
    CountryCode["TUV"] = "TUV";
    CountryCode["TWN"] = "TWN";
    CountryCode["TZA"] = "TZA";
    CountryCode["UGA"] = "UGA";
    CountryCode["UKR"] = "UKR";
    CountryCode["UMI"] = "UMI";
    CountryCode["URY"] = "URY";
    CountryCode["USA"] = "USA";
    CountryCode["UZB"] = "UZB";
    CountryCode["VAT"] = "VAT";
    CountryCode["VCT"] = "VCT";
    CountryCode["VEN"] = "VEN";
    CountryCode["VGB"] = "VGB";
    CountryCode["VIR"] = "VIR";
    CountryCode["VNM"] = "VNM";
    CountryCode["VUT"] = "VUT";
    CountryCode["WLF"] = "WLF";
    CountryCode["WSM"] = "WSM";
    CountryCode["YEM"] = "YEM";
    CountryCode["ZAF"] = "ZAF";
    CountryCode["ZMB"] = "ZMB";
    CountryCode["ZWE"] = "ZWE";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CreateSubscriptionsErrorCode;
(function (CreateSubscriptionsErrorCode) {
    CreateSubscriptionsErrorCode["Already_subscripted_same_package"] = "Already subscripted same package";
    CreateSubscriptionsErrorCode["Not_enough_balance"] = "Not enough balance";
    CreateSubscriptionsErrorCode["Server_internal_error"] = "Server internal error";
})(CreateSubscriptionsErrorCode = exports.CreateSubscriptionsErrorCode || (exports.CreateSubscriptionsErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DeliveryMedium;
(function (DeliveryMedium) {
    DeliveryMedium["EMAIL"] = "EMAIL";
    DeliveryMedium["SMS"] = "SMS";
    DeliveryMedium["PHONE"] = "PHONE";
    DeliveryMedium["UNKNOWN"] = "UNKNOWN";
})(DeliveryMedium = exports.DeliveryMedium || (exports.DeliveryMedium = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ExchangeId;
(function (ExchangeId) {
    ExchangeId["Unknown"] = "Unknown";
    ExchangeId["XASX"] = "XASX";
    ExchangeId["APX"] = "APX";
    ExchangeId["CHIA"] = "CHIA";
    ExchangeId["MFUND"] = "MFUND";
    ExchangeId["ALGO"] = "ALGO";
    ExchangeId["CMCX"] = "CMCX";
    ExchangeId["International"] = "International";
    ExchangeId["XTSX"] = "XTSX";
    ExchangeId["XNAS"] = "XNAS";
    ExchangeId["XASE"] = "XASE";
    ExchangeId["XNYS"] = "XNYS";
    ExchangeId["XTSE"] = "XTSE";
    ExchangeId["XTKS"] = "XTKS";
    ExchangeId["XJAS"] = "XJAS";
    ExchangeId["XHKG"] = "XHKG";
    ExchangeId["XSES"] = "XSES";
    ExchangeId["XLON"] = "XLON";
    ExchangeId["XPAR"] = "XPAR";
    ExchangeId["XMLI"] = "XMLI";
    ExchangeId["ALXP"] = "ALXP";
    ExchangeId["XSWX"] = "XSWX";
    ExchangeId["XVTX"] = "XVTX";
    ExchangeId["TNLA"] = "TNLA";
    ExchangeId["XAMS"] = "XAMS";
    ExchangeId["XBRU"] = "XBRU";
    ExchangeId["MLXB"] = "MLXB";
    ExchangeId["VPXB"] = "VPXB";
    ExchangeId["ALXB"] = "ALXB";
    ExchangeId["XETR"] = "XETR";
    ExchangeId["XFRA"] = "XFRA";
    ExchangeId["ARCX"] = "ARCX";
    ExchangeId["XNZE"] = "XNZE";
    ExchangeId["OOTC"] = "OOTC";
    ExchangeId["TNLB"] = "TNLB";
    ExchangeId["BATS"] = "BATS";
    ExchangeId["IEXG"] = "IEXG";
    ExchangeId["XJPX"] = "XJPX";
    ExchangeId["XCNQ"] = "XCNQ";
    ExchangeId["XCBO"] = "XCBO";
    ExchangeId["FINR"] = "FINR";
    ExchangeId["XSTO"] = "XSTO";
    ExchangeId["XMCE"] = "XMCE";
    ExchangeId["FNDK"] = "FNDK";
    ExchangeId["FNSE"] = "FNSE";
    ExchangeId["MABX"] = "MABX";
    ExchangeId["XCSE"] = "XCSE";
    ExchangeId["FNIS"] = "FNIS";
    ExchangeId["XICE"] = "XICE";
    ExchangeId["XLAT"] = "XLAT";
    ExchangeId["FOREX"] = "FOREX";
})(ExchangeId = exports.ExchangeId || (exports.ExchangeId = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FraudAssessmentFactorType;
(function (FraudAssessmentFactorType) {
    FraudAssessmentFactorType["DVI"] = "DVI";
    FraudAssessmentFactorType["KBA"] = "KBA";
    FraudAssessmentFactorType["KYC_PEP"] = "KYC_PEP";
    FraudAssessmentFactorType["KYC_SFD"] = "KYC_SFD";
    FraudAssessmentFactorType["KYC_SNC"] = "KYC_SNC";
    FraudAssessmentFactorType["KYC_VLC"] = "KYC_VLC";
    FraudAssessmentFactorType["VEVO_ENTITLEMENT"] = "VEVO_ENTITLEMENT";
    FraudAssessmentFactorType["VEVO_EXPIRY_DATE"] = "VEVO_EXPIRY_DATE";
    FraudAssessmentFactorType["VEVO_CLASS"] = "VEVO_CLASS";
    FraudAssessmentFactorType["VEVO_RESIDENCE_STATUS"] = "VEVO_RESIDENCE_STATUS";
    FraudAssessmentFactorType["PNV"] = "PNV";
    FraudAssessmentFactorType["SFA"] = "SFA";
    FraudAssessmentFactorType["WBC_BLOCK"] = "WBC_BLOCK";
    FraudAssessmentFactorType["WBC_REFER"] = "WBC_REFER";
})(FraudAssessmentFactorType = exports.FraudAssessmentFactorType || (exports.FraudAssessmentFactorType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FraudOutcome;
(function (FraudOutcome) {
    FraudOutcome["PASS"] = "PASS";
    FraudOutcome["FAIL"] = "FAIL";
    FraudOutcome["ERROR"] = "ERROR";
    FraudOutcome["TIMEOUT"] = "TIMEOUT";
    FraudOutcome["NOT_EXECUTED"] = "NOT_EXECUTED";
})(FraudOutcome = exports.FraudOutcome || (exports.FraudOutcome = {}));
/**
 *
 * @export
 * @enum {string}
 */
var GetVerifyIdentityErrorCode;
(function (GetVerifyIdentityErrorCode) {
    GetVerifyIdentityErrorCode["InvalidParameter"] = "InvalidParameter";
    GetVerifyIdentityErrorCode["IdentityRequestInternalError"] = "IdentityRequestInternalError";
})(GetVerifyIdentityErrorCode = exports.GetVerifyIdentityErrorCode || (exports.GetVerifyIdentityErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var IdentificationType;
(function (IdentificationType) {
    IdentificationType["DriversLicence"] = "DriversLicence";
    IdentificationType["Passport"] = "Passport";
    IdentificationType["Medicare"] = "Medicare";
    IdentificationType["None"] = "None";
})(IdentificationType = exports.IdentificationType || (exports.IdentificationType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LatestApplicationIdErrorCode;
(function (LatestApplicationIdErrorCode) {
    LatestApplicationIdErrorCode["InvalidParameter"] = "InvalidParameter";
    LatestApplicationIdErrorCode["ApplicationNotExists"] = "ApplicationNotExists";
})(LatestApplicationIdErrorCode = exports.LatestApplicationIdErrorCode || (exports.LatestApplicationIdErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MarketdataErrorCode;
(function (MarketdataErrorCode) {
    MarketdataErrorCode["SubscriptionInstrumentListTooLong"] = "SubscriptionInstrumentListTooLong";
    MarketdataErrorCode["MissingInput"] = "MissingInput";
    MarketdataErrorCode["SignUpConfirmFail"] = "SignUpConfirmFail";
    MarketdataErrorCode["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    MarketdataErrorCode["InvalidParameterException"] = "InvalidParameterException";
    MarketdataErrorCode["InvalidPasswordException"] = "InvalidPasswordException";
    MarketdataErrorCode["NotAuthorizedException"] = "NotAuthorizedException";
    MarketdataErrorCode["TooManyRequestsException"] = "TooManyRequestsException";
    MarketdataErrorCode["UsernameExistsException"] = "UsernameExistsException";
    MarketdataErrorCode["CodeMismatchException"] = "CodeMismatchException";
    MarketdataErrorCode["UserNotFoundException"] = "UserNotFoundException";
    MarketdataErrorCode["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    MarketdataErrorCode["LimitExceededException"] = "LimitExceededException";
    MarketdataErrorCode["ExpiredCodeException"] = "ExpiredCodeException";
    MarketdataErrorCode["ForgotPasswordException"] = "ForgotPasswordException";
    MarketdataErrorCode["UserNotConfirmedException"] = "UserNotConfirmedException";
})(MarketdataErrorCode = exports.MarketdataErrorCode || (exports.MarketdataErrorCode = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeChartV1ActionEnum;
(function (MarketdataSubscribeChartV1ActionEnum) {
    MarketdataSubscribeChartV1ActionEnum["request"] = "request";
})(MarketdataSubscribeChartV1ActionEnum = exports.MarketdataSubscribeChartV1ActionEnum || (exports.MarketdataSubscribeChartV1ActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeChartV1IntervalEnum;
(function (MarketdataSubscribeChartV1IntervalEnum) {
    MarketdataSubscribeChartV1IntervalEnum["_1m"] = "1m";
    MarketdataSubscribeChartV1IntervalEnum["_2m"] = "2m";
    MarketdataSubscribeChartV1IntervalEnum["_3m"] = "3m";
    MarketdataSubscribeChartV1IntervalEnum["_4m"] = "4m";
    MarketdataSubscribeChartV1IntervalEnum["_5m"] = "5m";
    MarketdataSubscribeChartV1IntervalEnum["_6m"] = "6m";
    MarketdataSubscribeChartV1IntervalEnum["_10m"] = "10m";
    MarketdataSubscribeChartV1IntervalEnum["_12m"] = "12m";
    MarketdataSubscribeChartV1IntervalEnum["_15m"] = "15m";
    MarketdataSubscribeChartV1IntervalEnum["_20m"] = "20m";
    MarketdataSubscribeChartV1IntervalEnum["_30m"] = "30m";
    MarketdataSubscribeChartV1IntervalEnum["_1h"] = "1h";
    MarketdataSubscribeChartV1IntervalEnum["_2h"] = "2h";
    MarketdataSubscribeChartV1IntervalEnum["_4h"] = "4h";
    MarketdataSubscribeChartV1IntervalEnum["_6h"] = "6h";
    MarketdataSubscribeChartV1IntervalEnum["_8h"] = "8h";
    MarketdataSubscribeChartV1IntervalEnum["_12h"] = "12h";
    MarketdataSubscribeChartV1IntervalEnum["daily"] = "daily";
    MarketdataSubscribeChartV1IntervalEnum["weekly"] = "weekly";
    MarketdataSubscribeChartV1IntervalEnum["monthly"] = "monthly";
    MarketdataSubscribeChartV1IntervalEnum["quarterly"] = "quarterly";
    MarketdataSubscribeChartV1IntervalEnum["semi_annually"] = "semi_annually";
    MarketdataSubscribeChartV1IntervalEnum["yearly"] = "yearly";
})(MarketdataSubscribeChartV1IntervalEnum = exports.MarketdataSubscribeChartV1IntervalEnum || (exports.MarketdataSubscribeChartV1IntervalEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeChartV1StartEnum;
(function (MarketdataSubscribeChartV1StartEnum) {
    MarketdataSubscribeChartV1StartEnum["_1m"] = "1m";
    MarketdataSubscribeChartV1StartEnum["_5m"] = "5m";
    MarketdataSubscribeChartV1StartEnum["_15m"] = "15m";
    MarketdataSubscribeChartV1StartEnum["_30m"] = "30m";
    MarketdataSubscribeChartV1StartEnum["_1h"] = "1h";
    MarketdataSubscribeChartV1StartEnum["_4h"] = "4h";
    MarketdataSubscribeChartV1StartEnum["_6h"] = "6h";
    MarketdataSubscribeChartV1StartEnum["_12h"] = "12h";
    MarketdataSubscribeChartV1StartEnum["_1D"] = "1D";
    MarketdataSubscribeChartV1StartEnum["_7D"] = "7D";
    MarketdataSubscribeChartV1StartEnum["_14D"] = "14D";
    MarketdataSubscribeChartV1StartEnum["_1M"] = "1M";
})(MarketdataSubscribeChartV1StartEnum = exports.MarketdataSubscribeChartV1StartEnum || (exports.MarketdataSubscribeChartV1StartEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeChartV1EndEnum;
(function (MarketdataSubscribeChartV1EndEnum) {
    MarketdataSubscribeChartV1EndEnum["_1m"] = "1m";
    MarketdataSubscribeChartV1EndEnum["_5m"] = "5m";
    MarketdataSubscribeChartV1EndEnum["_15m"] = "15m";
    MarketdataSubscribeChartV1EndEnum["_30m"] = "30m";
    MarketdataSubscribeChartV1EndEnum["_1h"] = "1h";
    MarketdataSubscribeChartV1EndEnum["_4h"] = "4h";
    MarketdataSubscribeChartV1EndEnum["_6h"] = "6h";
    MarketdataSubscribeChartV1EndEnum["_12h"] = "12h";
    MarketdataSubscribeChartV1EndEnum["_1D"] = "1D";
    MarketdataSubscribeChartV1EndEnum["_7D"] = "7D";
    MarketdataSubscribeChartV1EndEnum["_14D"] = "14D";
    MarketdataSubscribeChartV1EndEnum["_1M"] = "1M";
})(MarketdataSubscribeChartV1EndEnum = exports.MarketdataSubscribeChartV1EndEnum || (exports.MarketdataSubscribeChartV1EndEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeCourseOfSaleV1ActionEnum;
(function (MarketdataSubscribeCourseOfSaleV1ActionEnum) {
    MarketdataSubscribeCourseOfSaleV1ActionEnum["subscribe"] = "subscribe";
    MarketdataSubscribeCourseOfSaleV1ActionEnum["unsubscribe"] = "unsubscribe";
})(MarketdataSubscribeCourseOfSaleV1ActionEnum = exports.MarketdataSubscribeCourseOfSaleV1ActionEnum || (exports.MarketdataSubscribeCourseOfSaleV1ActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeDepthV1ActionEnum;
(function (MarketdataSubscribeDepthV1ActionEnum) {
    MarketdataSubscribeDepthV1ActionEnum["subscribe"] = "subscribe";
    MarketdataSubscribeDepthV1ActionEnum["unsubscribe"] = "unsubscribe";
})(MarketdataSubscribeDepthV1ActionEnum = exports.MarketdataSubscribeDepthV1ActionEnum || (exports.MarketdataSubscribeDepthV1ActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeQuoteV1ActionEnum;
(function (MarketdataSubscribeQuoteV1ActionEnum) {
    MarketdataSubscribeQuoteV1ActionEnum["subscribe"] = "subscribe";
    MarketdataSubscribeQuoteV1ActionEnum["unsubscribe"] = "unsubscribe";
})(MarketdataSubscribeQuoteV1ActionEnum = exports.MarketdataSubscribeQuoteV1ActionEnum || (exports.MarketdataSubscribeQuoteV1ActionEnum = {}));
/**
    * @export
    * @enum {string}
    */
var MarketdataSubscribeQuoteV1IntervalEnum;
(function (MarketdataSubscribeQuoteV1IntervalEnum) {
    MarketdataSubscribeQuoteV1IntervalEnum["realtime"] = "realtime";
    MarketdataSubscribeQuoteV1IntervalEnum["_1s"] = "1s";
})(MarketdataSubscribeQuoteV1IntervalEnum = exports.MarketdataSubscribeQuoteV1IntervalEnum || (exports.MarketdataSubscribeQuoteV1IntervalEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MedicareCardColour;
(function (MedicareCardColour) {
    MedicareCardColour["Green"] = "Green";
    MedicareCardColour["Blue"] = "Blue";
    MedicareCardColour["Yellow"] = "Yellow";
})(MedicareCardColour = exports.MedicareCardColour || (exports.MedicareCardColour = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MedicareCardColourType;
(function (MedicareCardColourType) {
    MedicareCardColourType["G"] = "G";
    MedicareCardColourType["Y"] = "Y";
    MedicareCardColourType["B"] = "B";
})(MedicareCardColourType = exports.MedicareCardColourType || (exports.MedicareCardColourType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OptionsMoneyStatus;
(function (OptionsMoneyStatus) {
    OptionsMoneyStatus["Unknown"] = "Unknown";
    OptionsMoneyStatus["In"] = "In";
    OptionsMoneyStatus["At"] = "At";
    OptionsMoneyStatus["Out"] = "Out";
})(OptionsMoneyStatus = exports.OptionsMoneyStatus || (exports.OptionsMoneyStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var OutcomeTypeEnum;
(function (OutcomeTypeEnum) {
    OutcomeTypeEnum["Success"] = "Success";
    OutcomeTypeEnum["Fail"] = "Fail";
})(OutcomeTypeEnum = exports.OutcomeTypeEnum || (exports.OutcomeTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProcessErrorCodeEnum;
(function (ProcessErrorCodeEnum) {
    ProcessErrorCodeEnum["RequestFailedRequestContextIsNull"] = "RequestFailedRequestContextIsNull";
    ProcessErrorCodeEnum["RequestFailedCRCRequiredForOperation"] = "RequestFailedCRCRequiredForOperation";
    ProcessErrorCodeEnum["RequestFailedEmailRequiredForOperation"] = "RequestFailedEmailRequiredForOperation";
    ProcessErrorCodeEnum["RequestFailedPhoneNumberRequiredForOperation"] = "RequestFailedPhoneNumberRequiredForOperation";
    ProcessErrorCodeEnum["RequestFailedInvalidBrand"] = "RequestFailedInvalidBrand";
    ProcessErrorCodeEnum["RequestFailedInvalidTokenIssuer"] = "RequestFailedInvalidTokenIssuer";
    ProcessErrorCodeEnum["RequestFailedMissingTokenExpiry"] = "RequestFailedMissingTokenExpiry";
    ProcessErrorCodeEnum["RequestFailedInvalidTokenExpiry"] = "RequestFailedInvalidTokenExpiry";
    ProcessErrorCodeEnum["RequestFailedTokenExpired"] = "RequestFailedTokenExpired";
    ProcessErrorCodeEnum["RequestFailedRequestDataIsNull"] = "RequestFailedRequestDataIsNull";
    ProcessErrorCodeEnum["RequestFailedErrorExecutingAction"] = "RequestFailedErrorExecutingAction";
    ProcessErrorCodeEnum["RequestFailedCompletedWorkflowFound"] = "RequestFailedCompletedWorkflowFound";
    ProcessErrorCodeEnum["RequestFailedWorkflowIdNotFound"] = "RequestFailedWorkflowIdNotFound";
    ProcessErrorCodeEnum["RequestFailedOriginRequiredForOperation"] = "RequestFailedOriginRequiredForOperation";
    ProcessErrorCodeEnum["RequestFailedOriginInvalidForOperation"] = "RequestFailedOriginInvalidForOperation";
    ProcessErrorCodeEnum["ValidationFailedMissingOnboardingModel"] = "ValidationFailedMissingOnboardingModel";
    ProcessErrorCodeEnum["ValidationFailedInvalidProviderType"] = "ValidationFailedInvalidProviderType";
    ProcessErrorCodeEnum["ValidationFailedMissingWorkflowId"] = "ValidationFailedMissingWorkflowId";
    ProcessErrorCodeEnum["ValidationFailedInvalidWorkflowId"] = "ValidationFailedInvalidWorkflowId";
    ProcessErrorCodeEnum["ValidationFailedInvalidStatusType"] = "ValidationFailedInvalidStatusType";
    ProcessErrorCodeEnum["ValidationFailedMissingContextData"] = "ValidationFailedMissingContextData";
    ProcessErrorCodeEnum["ValidationFailedInvalidContextData"] = "ValidationFailedInvalidContextData";
    ProcessErrorCodeEnum["ValidationFailedInvalidContextKey"] = "ValidationFailedInvalidContextKey";
    ProcessErrorCodeEnum["ValidationFailedInvalidCode"] = "ValidationFailedInvalidCode";
    ProcessErrorCodeEnum["ValidationFailedInvalidState"] = "ValidationFailedInvalidState";
    ProcessErrorCodeEnum["ValidationFailedInvalidError"] = "ValidationFailedInvalidError";
    ProcessErrorCodeEnum["ValidationFailedInvalidErrorDescription"] = "ValidationFailedInvalidErrorDescription";
    ProcessErrorCodeEnum["ValidationFailedMissingFirstName"] = "ValidationFailedMissingFirstName";
    ProcessErrorCodeEnum["ValidationFailedInvalidFirstName"] = "ValidationFailedInvalidFirstName";
    ProcessErrorCodeEnum["ValidationFailedMissingLastName"] = "ValidationFailedMissingLastName";
    ProcessErrorCodeEnum["ValidationFailedInvalidLastName"] = "ValidationFailedInvalidLastName";
    ProcessErrorCodeEnum["ValidationFailedMissingCallbackData"] = "ValidationFailedMissingCallbackData";
    ProcessErrorCodeEnum["ValidationFailedInvalidCallbackContent"] = "ValidationFailedInvalidCallbackContent";
    ProcessErrorCodeEnum["ValidationFailedInvalidTitle"] = "ValidationFailedInvalidTitle";
    ProcessErrorCodeEnum["ValidationFailedInvalidMiddleName"] = "ValidationFailedInvalidMiddleName";
    ProcessErrorCodeEnum["ValidationFailedInvalidDateOfBirth"] = "ValidationFailedInvalidDateOfBirth";
    ProcessErrorCodeEnum["ValidationFailedInvalidCountryOfResidence"] = "ValidationFailedInvalidCountryOfResidence";
    ProcessErrorCodeEnum["ValidationFailedInvalidNationality"] = "ValidationFailedInvalidNationality";
    ProcessErrorCodeEnum["ValidationFailedInvalidIdentityDocumentType"] = "ValidationFailedInvalidIdentityDocumentType";
    ProcessErrorCodeEnum["ValidationFailedInvalidPassExpiryDate"] = "ValidationFailedInvalidPassExpiryDate";
    ProcessErrorCodeEnum["ValidationFailedMissingUserModel"] = "ValidationFailedMissingUserModel";
    ProcessErrorCodeEnum["ValidationFailedMissingAddressModel"] = "ValidationFailedMissingAddressModel";
    ProcessErrorCodeEnum["ValidationFailedMissingTermsAndConditionsModel"] = "ValidationFailedMissingTermsAndConditionsModel";
    ProcessErrorCodeEnum["ValidationFailedMissingTaxInformationModel"] = "ValidationFailedMissingTaxInformationModel";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressLine1"] = "ValidationFailedInvalidAddressLine1";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressLine2"] = "ValidationFailedInvalidAddressLine2";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressLine3"] = "ValidationFailedInvalidAddressLine3";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressLine4"] = "ValidationFailedInvalidAddressLine4";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressCity"] = "ValidationFailedInvalidAddressCity";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressPostCode"] = "ValidationFailedInvalidAddressPostCode";
    ProcessErrorCodeEnum["ValidationFailedInvalidAddressCountryCode"] = "ValidationFailedInvalidAddressCountryCode";
    ProcessErrorCodeEnum["ValidationFailedInvalidTaxInformationPrimaryCountryCode"] = "ValidationFailedInvalidTaxInformationPrimaryCountryCode";
    ProcessErrorCodeEnum["ValidationFailedInvalidTaxInformationPrimaryTaxNumber"] = "ValidationFailedInvalidTaxInformationPrimaryTaxNumber";
    ProcessErrorCodeEnum["ValidationFailedInvalidTaxInformationOtherCountryCode"] = "ValidationFailedInvalidTaxInformationOtherCountryCode";
    ProcessErrorCodeEnum["ValidationFailedInvalidTaxInformationOtherTaxNumber"] = "ValidationFailedInvalidTaxInformationOtherTaxNumber";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentEmploymentStatus"] = "ValidationFailedInvalidEmploymentEmploymentStatus";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentCompanyName"] = "ValidationFailedInvalidEmploymentCompanyName";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentIndustry"] = "ValidationFailedInvalidEmploymentIndustry";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentBusinessName"] = "ValidationFailedInvalidEmploymentBusinessName";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentIndustryFurtherDetails"] = "ValidationFailedInvalidEmploymentIndustryFurtherDetails";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentIndustrySpecify"] = "ValidationFailedInvalidEmploymentIndustrySpecify";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentOccupation"] = "ValidationFailedInvalidEmploymentOccupation";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentOccupationSpecify"] = "ValidationFailedInvalidEmploymentOccupationSpecify";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentSourceOfFunds"] = "ValidationFailedInvalidEmploymentSourceOfFunds";
    ProcessErrorCodeEnum["ValidationFailedInvalidEmploymentSourceOfFundsSpecify"] = "ValidationFailedInvalidEmploymentSourceOfFundsSpecify";
    ProcessErrorCodeEnum["ValidationFailedInvalidKnowledgeInvestmentExperience"] = "ValidationFailedInvalidKnowledgeInvestmentExperience";
    ProcessErrorCodeEnum["ValidationFailedInvalidKnowledgeEducation"] = "ValidationFailedInvalidKnowledgeEducation";
    ProcessErrorCodeEnum["ValidationFailedInvalidKnowledgeWorkExperience"] = "ValidationFailedInvalidKnowledgeWorkExperience";
    ProcessErrorCodeEnum["ValidationFailedInvalidFinancialBackgroundAnnualIncome"] = "ValidationFailedInvalidFinancialBackgroundAnnualIncome";
    ProcessErrorCodeEnum["ValidationFailedInvalidFinancialBackgroundValueOfSavingsInvestments"] = "ValidationFailedInvalidFinancialBackgroundValueOfSavingsInvestments";
    ProcessErrorCodeEnum["ValidationFailedInvalidFinancialBackgroundPurposeOfAccount"] = "ValidationFailedInvalidFinancialBackgroundPurposeOfAccount";
    ProcessErrorCodeEnum["ApplicationSubmissionFailed"] = "ApplicationSubmissionFailed";
    ProcessErrorCodeEnum["ValidationFailedInvalidHanyuPinyinName"] = "ValidationFailedInvalidHanyuPinyinName";
    ProcessErrorCodeEnum["ValidationFailedInvalidHanyuPinyinAliasName"] = "ValidationFailedInvalidHanyuPinyinAliasName";
    ProcessErrorCodeEnum["ApplicationSubmissionAlreadyPerformed"] = "ApplicationSubmissionAlreadyPerformed";
    ProcessErrorCodeEnum["ValidationFailedInvalidClientEnteredFirstName"] = "ValidationFailedInvalidClientEnteredFirstName";
    ProcessErrorCodeEnum["ValidationFailedInvalidClientEnteredMiddleName"] = "ValidationFailedInvalidClientEnteredMiddleName";
    ProcessErrorCodeEnum["ValidationFailedInvalidClientEnteredLastName"] = "ValidationFailedInvalidClientEnteredLastName";
    ProcessErrorCodeEnum["ValidationFailedInvalidPromoCode"] = "ValidationFailedInvalidPromoCode";
})(ProcessErrorCodeEnum = exports.ProcessErrorCodeEnum || (exports.ProcessErrorCodeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SecurityCategory;
(function (SecurityCategory) {
    SecurityCategory["Unknown"] = "Unknown";
    SecurityCategory["Equity"] = "Equity";
    SecurityCategory["InterestRate"] = "InterestRate";
    SecurityCategory["Option"] = "Option";
    SecurityCategory["Warrant"] = "Warrant";
    SecurityCategory["Index"] = "Index";
    SecurityCategory["Etp"] = "Etp";
    SecurityCategory["MFund"] = "MFund";
    SecurityCategory["TraCR"] = "TraCR";
    SecurityCategory["Combo"] = "Combo";
})(SecurityCategory = exports.SecurityCategory || (exports.SecurityCategory = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ServiceProviderTypeEnum;
(function (ServiceProviderTypeEnum) {
    ServiceProviderTypeEnum["MyInfo"] = "MyInfo";
    ServiceProviderTypeEnum["Jumio"] = "Jumio";
})(ServiceProviderTypeEnum = exports.ServiceProviderTypeEnum || (exports.ServiceProviderTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var State;
(function (State) {
    State["NSW"] = "NSW";
    State["VIC"] = "VIC";
    State["TAS"] = "TAS";
    State["SA"] = "SA";
    State["QLD"] = "QLD";
    State["ACT"] = "ACT";
    State["NT"] = "NT";
    State["WA"] = "WA";
    State["AAT"] = "AAT";
})(State = exports.State || (exports.State = {}));
/**
 *
 * @export
 * @enum {string}
 */
var StatusTypeEnum;
(function (StatusTypeEnum) {
    StatusTypeEnum["None"] = "None";
    StatusTypeEnum["Success"] = "Success";
    StatusTypeEnum["Fail"] = "Fail";
    StatusTypeEnum["InProgress"] = "InProgress";
})(StatusTypeEnum = exports.StatusTypeEnum || (exports.StatusTypeEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SymbolRefreshInterval;
(function (SymbolRefreshInterval) {
    SymbolRefreshInterval["Realtime"] = "Realtime";
    SymbolRefreshInterval["_1s"] = "1s";
})(SymbolRefreshInterval = exports.SymbolRefreshInterval || (exports.SymbolRefreshInterval = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TaxResidentType;
(function (TaxResidentType) {
    TaxResidentType["Australia"] = "Australia";
    TaxResidentType["Overseas"] = "Overseas";
    TaxResidentType["AUOverseas"] = "AUOverseas";
})(TaxResidentType = exports.TaxResidentType || (exports.TaxResidentType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TradingState;
(function (TradingState) {
    TradingState["Unknown"] = "Unknown";
    TradingState["AbbAuction"] = "AbbAuction";
    TradingState["Adjust"] = "Adjust";
    TradingState["AdjustOn"] = "AdjustOn";
    TradingState["Close"] = "Close";
    TradingState["Cspa"] = "Cspa";
    TradingState["Enquire"] = "Enquire";
    TradingState["LateTrading"] = "LateTrading";
    TradingState["Open"] = "Open";
    TradingState["OpenNightTrading"] = "OpenNightTrading";
    TradingState["PreCspa"] = "PreCspa";
    TradingState["PreNightTrading"] = "PreNightTrading";
    TradingState["PreNr"] = "PreNr";
    TradingState["PreOpen"] = "PreOpen";
    TradingState["PurgeOrders"] = "PurgeOrders";
    TradingState["Suspend"] = "Suspend";
    TradingState["TradingHalt"] = "TradingHalt";
    TradingState["InOpen"] = "InOpen";
    TradingState["AfterHoursAdjust"] = "AfterHoursAdjust";
    TradingState["RegulatoryHalt"] = "RegulatoryHalt";
    TradingState["OpenQuoteDisplay"] = "OpenQuoteDisplay";
    TradingState["OpenVmb"] = "OpenVmb";
    TradingState["WaitVmb"] = "WaitVmb";
    TradingState["InternationalHalt"] = "InternationalHalt";
    TradingState["PreTrade"] = "PreTrade";
    TradingState["PostTrade"] = "PostTrade";
})(TradingState = exports.TradingState || (exports.TradingState = {}));
/**
 *
 * @export
 * @enum {string}
 */
var UsersErrorCode;
(function (UsersErrorCode) {
    UsersErrorCode["SignUpConfirmFail"] = "SignUpConfirmFail";
    UsersErrorCode["MissingInput"] = "MissingInput";
    UsersErrorCode["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UsersErrorCode["InvalidParameterException"] = "InvalidParameterException";
    UsersErrorCode["InvalidPasswordException"] = "InvalidPasswordException";
    UsersErrorCode["NotAuthorizedException"] = "NotAuthorizedException";
    UsersErrorCode["TooManyRequestsException"] = "TooManyRequestsException";
    UsersErrorCode["UsernameExistsException"] = "UsernameExistsException";
    UsersErrorCode["CodeMismatchException"] = "CodeMismatchException";
    UsersErrorCode["UserNotFoundException"] = "UserNotFoundException";
    UsersErrorCode["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    UsersErrorCode["LimitExceededException"] = "LimitExceededException";
    UsersErrorCode["ExpiredCodeException"] = "ExpiredCodeException";
    UsersErrorCode["ForgotPasswordException"] = "ForgotPasswordException";
    UsersErrorCode["UserNotConfirmedException"] = "UserNotConfirmedException";
})(UsersErrorCode = exports.UsersErrorCode || (exports.UsersErrorCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ValidationOutcome;
(function (ValidationOutcome) {
    ValidationOutcome["Valid"] = "Valid";
    ValidationOutcome["InvalidName"] = "InvalidName";
    ValidationOutcome["InvalidDob"] = "InvalidDob";
    ValidationOutcome["InvalidAddress"] = "InvalidAddress";
    ValidationOutcome["InvalidDriversLicence"] = "InvalidDriversLicence";
    ValidationOutcome["InvalidMedicareCard"] = "InvalidMedicareCard";
    ValidationOutcome["InvalidPassport"] = "InvalidPassport";
    ValidationOutcome["EmptyReference"] = "EmptyReference";
    ValidationOutcome["IdMatrixInternalException"] = "IdMatrixInternalException";
})(ValidationOutcome = exports.ValidationOutcome || (exports.ValidationOutcome = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ValidationOutcome1;
(function (ValidationOutcome1) {
    ValidationOutcome1["Valid"] = "Valid";
    ValidationOutcome1["InvalidName"] = "InvalidName";
    ValidationOutcome1["InvalidDob"] = "InvalidDob";
    ValidationOutcome1["InvalidAddress"] = "InvalidAddress";
    ValidationOutcome1["InvalidDriversLicence"] = "InvalidDriversLicence";
    ValidationOutcome1["InvalidMedicareCard"] = "InvalidMedicareCard";
    ValidationOutcome1["InvalidPassport"] = "InvalidPassport";
    ValidationOutcome1["EmptyReference"] = "EmptyReference";
    ValidationOutcome1["IdMatrixInternalException"] = "IdMatrixInternalException";
    ValidationOutcome1["RequestLimitExceeded"] = "RequestLimitExceeded";
    ValidationOutcome1["EmptyMessageId"] = "EmptyMessageId";
    ValidationOutcome1["InvalidParameter"] = "InvalidParameter";
})(ValidationOutcome1 = exports.ValidationOutcome1 || (exports.ValidationOutcome1 = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VerificationOutcome;
(function (VerificationOutcome) {
    VerificationOutcome["ACCEPT"] = "ACCEPT";
    VerificationOutcome["REJECT"] = "REJECT";
    VerificationOutcome["REJECT_ON_EXCLUSION"] = "REJECT_ON_EXCLUSION";
    VerificationOutcome["TIMEOUT"] = "TIMEOUT";
    VerificationOutcome["ERROR"] = "ERROR";
})(VerificationOutcome = exports.VerificationOutcome || (exports.VerificationOutcome = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VerificationOutcome1;
(function (VerificationOutcome1) {
    VerificationOutcome1["ACCEPT"] = "ACCEPT";
    VerificationOutcome1["REJECT"] = "REJECT";
    VerificationOutcome1["REJECT_ON_EXCLUSION"] = "REJECT_ON_EXCLUSION";
    VerificationOutcome1["TIMEOUT"] = "TIMEOUT";
    VerificationOutcome1["ERROR"] = "ERROR";
    VerificationOutcome1["IN_PROGRESS"] = "IN_PROGRESS";
})(VerificationOutcome1 = exports.VerificationOutcome1 || (exports.VerificationOutcome1 = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WfeForgotPasswordSubmitResultState;
(function (WfeForgotPasswordSubmitResultState) {
    WfeForgotPasswordSubmitResultState["Unknown"] = "Unknown";
    WfeForgotPasswordSubmitResultState["Success"] = "Success";
    WfeForgotPasswordSubmitResultState["Error"] = "Error";
    WfeForgotPasswordSubmitResultState["PasswordInsecure"] = "PasswordInsecure";
    WfeForgotPasswordSubmitResultState["AuthorisationCodeExpired"] = "AuthorisationCodeExpired";
})(WfeForgotPasswordSubmitResultState = exports.WfeForgotPasswordSubmitResultState || (exports.WfeForgotPasswordSubmitResultState = {}));
/**
 *
 * @export
 * @enum {string}
 */
var WfeLoginApiResultState;
(function (WfeLoginApiResultState) {
    WfeLoginApiResultState["Unknown"] = "Unknown";
    WfeLoginApiResultState["Error"] = "Error";
    WfeLoginApiResultState["Success"] = "Success";
    WfeLoginApiResultState["InterceptorRequired"] = "InterceptorRequired";
    WfeLoginApiResultState["SetPasswordRequired"] = "SetPasswordRequired";
})(WfeLoginApiResultState = exports.WfeLoginApiResultState || (exports.WfeLoginApiResultState = {}));
/**
 * AddressApi - axios parameter creator
 * @export
 */
var AddressApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Address Format  - Format a address by global address string
         * @summary Look up address
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressFormat: function (address, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'address' is not null or undefined
                    (0, common_1.assertParamExists)('addressFormat', 'address', address);
                    localVarPath = "/address/format";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (address !== undefined) {
                        localVarQueryParameter['address'] = address;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Address look up  - Search potential addresses by request string
         * @summary Look up addresses
         * @param {AddressQasLookupRequest} addressQasLookupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressSearch: function (addressQasLookupRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'addressQasLookupRequest' is not null or undefined
                    (0, common_1.assertParamExists)('addressSearch', 'addressQasLookupRequest', addressQasLookupRequest);
                    localVarPath = "/address/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addressQasLookupRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AddressApiAxiosParamCreator = AddressApiAxiosParamCreator;
/**
 * AddressApi - functional programming interface
 * @export
 */
var AddressApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AddressApiAxiosParamCreator)(configuration);
    return {
        /**
         * Address Format  - Format a address by global address string
         * @summary Look up address
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressFormat: function (address, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressFormat(address, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Address look up  - Search potential addresses by request string
         * @summary Look up addresses
         * @param {AddressQasLookupRequest} addressQasLookupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressSearch: function (addressQasLookupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressSearch(addressQasLookupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AddressApiFp = AddressApiFp;
/**
 * AddressApi - factory interface
 * @export
 */
var AddressApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AddressApiFp)(configuration);
    return {
        /**
         * Address Format  - Format a address by global address string
         * @summary Look up address
         * @param {string} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressFormat: function (address, options) {
            return localVarFp.addressFormat(address, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Address look up  - Search potential addresses by request string
         * @summary Look up addresses
         * @param {AddressQasLookupRequest} addressQasLookupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressSearch: function (addressQasLookupRequest, options) {
            return localVarFp.addressSearch(addressQasLookupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AddressApiFactory = AddressApiFactory;
/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
var AddressApi = /** @class */ (function (_super) {
    __extends(AddressApi, _super);
    function AddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Address Format  - Format a address by global address string
     * @summary Look up address
     * @param {string} address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.addressFormat = function (address, options) {
        var _this = this;
        return (0, exports.AddressApiFp)(this.configuration).addressFormat(address, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Address look up  - Search potential addresses by request string
     * @summary Look up addresses
     * @param {AddressQasLookupRequest} addressQasLookupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    AddressApi.prototype.addressSearch = function (addressQasLookupRequest, options) {
        var _this = this;
        return (0, exports.AddressApiFp)(this.configuration).addressSearch(addressQasLookupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AddressApi;
}(base_1.BaseAPI));
exports.AddressApi = AddressApi;
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
var ApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check application submit record
         * @summary using idToken to retrieve the application submit record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        latestApplicationId: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/application/latest-application-id";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Check submitted application status
         * @summary send application id to retrieve the status
         * @param {string} applicationGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: function (applicationGuid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'applicationGuid' is not null or undefined
                    (0, common_1.assertParamExists)('status', 'applicationGuid', applicationGuid);
                    localVarPath = "/application/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applicationGuid !== undefined) {
                        localVarQueryParameter['applicationGuid'] = applicationGuid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Submit application
         * @summary Submit client application, return application\'s status and reference.
         * @param {OnlineApplicationRequest} onlineApplicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (onlineApplicationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'onlineApplicationRequest' is not null or undefined
                    (0, common_1.assertParamExists)('submit', 'onlineApplicationRequest', onlineApplicationRequest);
                    localVarPath = "/application/submit";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onlineApplicationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ApplicationApiAxiosParamCreator = ApplicationApiAxiosParamCreator;
/**
 * ApplicationApi - functional programming interface
 * @export
 */
var ApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check application submit record
         * @summary using idToken to retrieve the application submit record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        latestApplicationId: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.latestApplicationId(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check submitted application status
         * @summary send application id to retrieve the status
         * @param {string} applicationGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: function (applicationGuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.status(applicationGuid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Submit application
         * @summary Submit client application, return application\'s status and reference.
         * @param {OnlineApplicationRequest} onlineApplicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (onlineApplicationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.submit(onlineApplicationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationApiFp = ApplicationApiFp;
/**
 * ApplicationApi - factory interface
 * @export
 */
var ApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationApiFp)(configuration);
    return {
        /**
         * Check application submit record
         * @summary using idToken to retrieve the application submit record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        latestApplicationId: function (options) {
            return localVarFp.latestApplicationId(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check submitted application status
         * @summary send application id to retrieve the status
         * @param {string} applicationGuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: function (applicationGuid, options) {
            return localVarFp.status(applicationGuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Submit application
         * @summary Submit client application, return application\'s status and reference.
         * @param {OnlineApplicationRequest} onlineApplicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (onlineApplicationRequest, options) {
            return localVarFp.submit(onlineApplicationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationApiFactory = ApplicationApiFactory;
/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
var ApplicationApi = /** @class */ (function (_super) {
    __extends(ApplicationApi, _super);
    function ApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check application submit record
     * @summary using idToken to retrieve the application submit record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.latestApplicationId = function (options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).latestApplicationId(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check submitted application status
     * @summary send application id to retrieve the status
     * @param {string} applicationGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.status = function (applicationGuid, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).status(applicationGuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Submit application
     * @summary Submit client application, return application\'s status and reference.
     * @param {OnlineApplicationRequest} onlineApplicationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.submit = function (onlineApplicationRequest, options) {
        var _this = this;
        return (0, exports.ApplicationApiFp)(this.configuration).submit(onlineApplicationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationApi;
}(base_1.BaseAPI));
exports.ApplicationApi = ApplicationApi;
/**
 * DeveloperApi - axios parameter creator
 * @export
 */
var DeveloperApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * OpenAPI RapiDoc Portal for Developers
         * @summary OpenAPI UI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerPortal: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/developers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Swagger API definiton
         * @summary API Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerSpec: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/developers/swagger.json";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeveloperApiAxiosParamCreator = DeveloperApiAxiosParamCreator;
/**
 * DeveloperApi - functional programming interface
 * @export
 */
var DeveloperApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeveloperApiAxiosParamCreator)(configuration);
    return {
        /**
         * OpenAPI RapiDoc Portal for Developers
         * @summary OpenAPI UI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerPortal: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.developerPortal(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Swagger API definiton
         * @summary API Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerSpec: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.swaggerSpec(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeveloperApiFp = DeveloperApiFp;
/**
 * DeveloperApi - factory interface
 * @export
 */
var DeveloperApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeveloperApiFp)(configuration);
    return {
        /**
         * OpenAPI RapiDoc Portal for Developers
         * @summary OpenAPI UI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerPortal: function (options) {
            return localVarFp.developerPortal(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Swagger API definiton
         * @summary API Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        swaggerSpec: function (options) {
            return localVarFp.swaggerSpec(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeveloperApiFactory = DeveloperApiFactory;
/**
 * DeveloperApi - object-oriented interface
 * @export
 * @class DeveloperApi
 * @extends {BaseAPI}
 */
var DeveloperApi = /** @class */ (function (_super) {
    __extends(DeveloperApi, _super);
    function DeveloperApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * OpenAPI RapiDoc Portal for Developers
     * @summary OpenAPI UI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.developerPortal = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).developerPortal(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Swagger API definiton
     * @summary API Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeveloperApi
     */
    DeveloperApi.prototype.swaggerSpec = function (options) {
        var _this = this;
        return (0, exports.DeveloperApiFp)(this.configuration).swaggerSpec(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeveloperApi;
}(base_1.BaseAPI));
exports.DeveloperApi = DeveloperApi;
/**
 * IdentityApi - axios parameter creator
 * @export
 */
var IdentityApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieve user entered data for identity verification.
         * @summary Retrieve user entered data for identity verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerifyIdentity: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/identity/get-verify-identity";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Submit user data to do id check and returns a referenceId generated from SQS for user to check id verify result.
         * @param {VerifyIdentityRequest2} verifyIdentityRequest2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyIdentitySubmit: function (verifyIdentityRequest2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'verifyIdentityRequest2' is not null or undefined
                            (0, common_1.assertParamExists)('identityVerifyIdentitySubmit', 'verifyIdentityRequest2', verifyIdentityRequest2);
                            localVarPath = "/identity/verify-identity-submit";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyIdentityRequest2, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Check id verify status
         * @summary send message id to retrieve the id check status
         * @param {IdentityStatusRequest} identityStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyStatus: function (identityStatusRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'identityStatusRequest' is not null or undefined
                    (0, common_1.assertParamExists)('identityVerifyStatus', 'identityStatusRequest', identityStatusRequest);
                    localVarPath = "/identity/verify-identity-status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(identityStatusRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.IdentityApiAxiosParamCreator = IdentityApiAxiosParamCreator;
/**
 * IdentityApi - functional programming interface
 * @export
 */
var IdentityApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IdentityApiAxiosParamCreator)(configuration);
    return {
        /**
         * Retrieve user entered data for identity verification.
         * @summary Retrieve user entered data for identity verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerifyIdentity: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getVerifyIdentity(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Submit user data to do id check and returns a referenceId generated from SQS for user to check id verify result.
         * @param {VerifyIdentityRequest2} verifyIdentityRequest2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyIdentitySubmit: function (verifyIdentityRequest2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.identityVerifyIdentitySubmit(verifyIdentityRequest2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Check id verify status
         * @summary send message id to retrieve the id check status
         * @param {IdentityStatusRequest} identityStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyStatus: function (identityStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.identityVerifyStatus(identityStatusRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IdentityApiFp = IdentityApiFp;
/**
 * IdentityApi - factory interface
 * @export
 */
var IdentityApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IdentityApiFp)(configuration);
    return {
        /**
         * Retrieve user entered data for identity verification.
         * @summary Retrieve user entered data for identity verification.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerifyIdentity: function (options) {
            return localVarFp.getVerifyIdentity(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Submit user data to do id check and returns a referenceId generated from SQS for user to check id verify result.
         * @param {VerifyIdentityRequest2} verifyIdentityRequest2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyIdentitySubmit: function (verifyIdentityRequest2, options) {
            return localVarFp.identityVerifyIdentitySubmit(verifyIdentityRequest2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check id verify status
         * @summary send message id to retrieve the id check status
         * @param {IdentityStatusRequest} identityStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityVerifyStatus: function (identityStatusRequest, options) {
            return localVarFp.identityVerifyStatus(identityStatusRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IdentityApiFactory = IdentityApiFactory;
/**
 * IdentityApi - object-oriented interface
 * @export
 * @class IdentityApi
 * @extends {BaseAPI}
 */
var IdentityApi = /** @class */ (function (_super) {
    __extends(IdentityApi, _super);
    function IdentityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieve user entered data for identity verification.
     * @summary Retrieve user entered data for identity verification.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    IdentityApi.prototype.getVerifyIdentity = function (options) {
        var _this = this;
        return (0, exports.IdentityApiFp)(this.configuration).getVerifyIdentity(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Submit user data to do id check and returns a referenceId generated from SQS for user to check id verify result.
     * @param {VerifyIdentityRequest2} verifyIdentityRequest2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    IdentityApi.prototype.identityVerifyIdentitySubmit = function (verifyIdentityRequest2, options) {
        var _this = this;
        return (0, exports.IdentityApiFp)(this.configuration).identityVerifyIdentitySubmit(verifyIdentityRequest2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check id verify status
     * @summary send message id to retrieve the id check status
     * @param {IdentityStatusRequest} identityStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityApi
     */
    IdentityApi.prototype.identityVerifyStatus = function (identityStatusRequest, options) {
        var _this = this;
        return (0, exports.IdentityApiFp)(this.configuration).identityVerifyStatus(identityStatusRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IdentityApi;
}(base_1.BaseAPI));
exports.IdentityApi = IdentityApi;
/**
 * IdentityInternationalApi - axios parameter creator
 * @export
 */
var IdentityInternationalApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Complete a workflow process for the specified provider
         * @param {CompleteProcessRequestModel} [completeProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processComplete: function (completeProcessRequestModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/identity-intl/verification/Process/complete";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completeProcessRequestModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Poll a workflow process for the specified provider and workflowId
         * @param {PollProcessRequestModel} [pollProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPoll: function (pollProcessRequestModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/identity-intl/verification/Process/poll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pollProcessRequestModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Start a workflow process for the specified provider
         * @param {StartProcessRequestModel} [startProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStart: function (startProcessRequestModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/identity-intl/verification/Process/start";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(startProcessRequestModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieve user data for an onboarding user
         * @param {RetrieveApplicationRequestModel} [retrieveApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (retrieveApplicationRequestModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/identity-intl/verification/Application/retrieve";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retrieveApplicationRequestModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Submit an application for an onboarding user
         * @param {SubmitApplicationRequestModel} [submitApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (submitApplicationRequestModel, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/identity-intl/verification/Application/submit";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(submitApplicationRequestModel, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.IdentityInternationalApiAxiosParamCreator = IdentityInternationalApiAxiosParamCreator;
/**
 * IdentityInternationalApi - functional programming interface
 * @export
 */
var IdentityInternationalApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IdentityInternationalApiAxiosParamCreator)(configuration);
    return {
        /**
         * Complete a workflow process for the specified provider
         * @param {CompleteProcessRequestModel} [completeProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processComplete: function (completeProcessRequestModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processComplete(completeProcessRequestModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Poll a workflow process for the specified provider and workflowId
         * @param {PollProcessRequestModel} [pollProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPoll: function (pollProcessRequestModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processPoll(pollProcessRequestModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Start a workflow process for the specified provider
         * @param {StartProcessRequestModel} [startProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStart: function (startProcessRequestModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processStart(startProcessRequestModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieve user data for an onboarding user
         * @param {RetrieveApplicationRequestModel} [retrieveApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (retrieveApplicationRequestModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieve(retrieveApplicationRequestModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Submit an application for an onboarding user
         * @param {SubmitApplicationRequestModel} [submitApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (submitApplicationRequestModel, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.submit(submitApplicationRequestModel, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IdentityInternationalApiFp = IdentityInternationalApiFp;
/**
 * IdentityInternationalApi - factory interface
 * @export
 */
var IdentityInternationalApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IdentityInternationalApiFp)(configuration);
    return {
        /**
         * Complete a workflow process for the specified provider
         * @param {CompleteProcessRequestModel} [completeProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processComplete: function (completeProcessRequestModel, options) {
            return localVarFp.processComplete(completeProcessRequestModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Poll a workflow process for the specified provider and workflowId
         * @param {PollProcessRequestModel} [pollProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPoll: function (pollProcessRequestModel, options) {
            return localVarFp.processPoll(pollProcessRequestModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Start a workflow process for the specified provider
         * @param {StartProcessRequestModel} [startProcessRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processStart: function (startProcessRequestModel, options) {
            return localVarFp.processStart(startProcessRequestModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieve user data for an onboarding user
         * @param {RetrieveApplicationRequestModel} [retrieveApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (retrieveApplicationRequestModel, options) {
            return localVarFp.retrieve(retrieveApplicationRequestModel, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Submit an application for an onboarding user
         * @param {SubmitApplicationRequestModel} [submitApplicationRequestModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: function (submitApplicationRequestModel, options) {
            return localVarFp.submit(submitApplicationRequestModel, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IdentityInternationalApiFactory = IdentityInternationalApiFactory;
/**
 * IdentityInternationalApi - object-oriented interface
 * @export
 * @class IdentityInternationalApi
 * @extends {BaseAPI}
 */
var IdentityInternationalApi = /** @class */ (function (_super) {
    __extends(IdentityInternationalApi, _super);
    function IdentityInternationalApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Complete a workflow process for the specified provider
     * @param {CompleteProcessRequestModel} [completeProcessRequestModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityInternationalApi
     */
    IdentityInternationalApi.prototype.processComplete = function (completeProcessRequestModel, options) {
        var _this = this;
        return (0, exports.IdentityInternationalApiFp)(this.configuration).processComplete(completeProcessRequestModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Poll a workflow process for the specified provider and workflowId
     * @param {PollProcessRequestModel} [pollProcessRequestModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityInternationalApi
     */
    IdentityInternationalApi.prototype.processPoll = function (pollProcessRequestModel, options) {
        var _this = this;
        return (0, exports.IdentityInternationalApiFp)(this.configuration).processPoll(pollProcessRequestModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Start a workflow process for the specified provider
     * @param {StartProcessRequestModel} [startProcessRequestModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityInternationalApi
     */
    IdentityInternationalApi.prototype.processStart = function (startProcessRequestModel, options) {
        var _this = this;
        return (0, exports.IdentityInternationalApiFp)(this.configuration).processStart(startProcessRequestModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieve user data for an onboarding user
     * @param {RetrieveApplicationRequestModel} [retrieveApplicationRequestModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityInternationalApi
     */
    IdentityInternationalApi.prototype.retrieve = function (retrieveApplicationRequestModel, options) {
        var _this = this;
        return (0, exports.IdentityInternationalApiFp)(this.configuration).retrieve(retrieveApplicationRequestModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Submit an application for an onboarding user
     * @param {SubmitApplicationRequestModel} [submitApplicationRequestModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityInternationalApi
     */
    IdentityInternationalApi.prototype.submit = function (submitApplicationRequestModel, options) {
        var _this = this;
        return (0, exports.IdentityInternationalApiFp)(this.configuration).submit(submitApplicationRequestModel, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IdentityInternationalApi;
}(base_1.BaseAPI));
exports.IdentityInternationalApi = IdentityInternationalApi;
/**
 * MarketdataApi - axios parameter creator
 * @export
 */
var MarketdataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Refresh token
         * @summary Marketdata WSS endpoint. Allows a user to refresh the token before the accessToken expires. Returns a JWT accessToken in the response.
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataRefreshTokenV1: function (inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'inlineObject' is not null or undefined
                    (0, common_1.assertParamExists)('marketdataRefreshTokenV1', 'inlineObject', inlineObject);
                    localVarPath = "/wss/marketdata/refresh-token-v1";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get chart data for Candlestick/Kline over a time-interval for a particular symbol
         * @summary Marketdata WSS endpoint to retrieve chart data
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeChartV1: function (inlineObject3, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject3' is not null or undefined
                            (0, common_1.assertParamExists)('marketdataSubscribeChartV1', 'inlineObject3', inlineObject3);
                            localVarPath = "/wss/marketdata/subscribe-chart-v1";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject3, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Subscribe to executed course of sales.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Course Of Sales
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeCourseOfSaleV1: function (inlineObject1, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject1' is not null or undefined
                            (0, common_1.assertParamExists)('marketdataSubscribeCourseOfSaleV1', 'inlineObject1', inlineObject1);
                            localVarPath = "/wss/marketdata/subscribe-course-of-sale-v1";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject1, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Market Data Depth.  Depth response is the container for the overall response. It contains two lists, one for each side of the market.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Depth
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeDepthV1: function (inlineObject2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject2' is not null or undefined
                            (0, common_1.assertParamExists)('marketdataSubscribeDepthV1', 'inlineObject2', inlineObject2);
                            localVarPath = "/wss/marketdata/subscribe-depth-v1";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject2, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Subscribe quote updates for a list of symbols at a maximum rate defined by interval (default is 1 second). Every message contains all fields. A maximum of up to 200 quotes can be subscribed.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Quotes
         * @param {QuoteSubscribeRequestWrapper} quoteSubscribeRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeQuoteV1: function (quoteSubscribeRequestWrapper, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quoteSubscribeRequestWrapper' is not null or undefined
                            (0, common_1.assertParamExists)('marketdataSubscribeQuoteV1', 'quoteSubscribeRequestWrapper', quoteSubscribeRequestWrapper);
                            localVarPath = "/wss/marketdata/subscribeQuoteV1";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quoteSubscribeRequestWrapper, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MarketdataApiAxiosParamCreator = MarketdataApiAxiosParamCreator;
/**
 * MarketdataApi - functional programming interface
 * @export
 */
var MarketdataApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MarketdataApiAxiosParamCreator)(configuration);
    return {
        /**
         * Refresh token
         * @summary Marketdata WSS endpoint. Allows a user to refresh the token before the accessToken expires. Returns a JWT accessToken in the response.
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataRefreshTokenV1: function (inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.marketdataRefreshTokenV1(inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get chart data for Candlestick/Kline over a time-interval for a particular symbol
         * @summary Marketdata WSS endpoint to retrieve chart data
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeChartV1: function (inlineObject3, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.marketdataSubscribeChartV1(inlineObject3, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Subscribe to executed course of sales.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Course Of Sales
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeCourseOfSaleV1: function (inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.marketdataSubscribeCourseOfSaleV1(inlineObject1, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Market Data Depth.  Depth response is the container for the overall response. It contains two lists, one for each side of the market.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Depth
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeDepthV1: function (inlineObject2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.marketdataSubscribeDepthV1(inlineObject2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Subscribe quote updates for a list of symbols at a maximum rate defined by interval (default is 1 second). Every message contains all fields. A maximum of up to 200 quotes can be subscribed.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Quotes
         * @param {QuoteSubscribeRequestWrapper} quoteSubscribeRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeQuoteV1: function (quoteSubscribeRequestWrapper, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.marketdataSubscribeQuoteV1(quoteSubscribeRequestWrapper, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MarketdataApiFp = MarketdataApiFp;
/**
 * MarketdataApi - factory interface
 * @export
 */
var MarketdataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MarketdataApiFp)(configuration);
    return {
        /**
         * Refresh token
         * @summary Marketdata WSS endpoint. Allows a user to refresh the token before the accessToken expires. Returns a JWT accessToken in the response.
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataRefreshTokenV1: function (inlineObject, options) {
            return localVarFp.marketdataRefreshTokenV1(inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get chart data for Candlestick/Kline over a time-interval for a particular symbol
         * @summary Marketdata WSS endpoint to retrieve chart data
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeChartV1: function (inlineObject3, options) {
            return localVarFp.marketdataSubscribeChartV1(inlineObject3, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Subscribe to executed course of sales.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Course Of Sales
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeCourseOfSaleV1: function (inlineObject1, options) {
            return localVarFp.marketdataSubscribeCourseOfSaleV1(inlineObject1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Market Data Depth.  Depth response is the container for the overall response. It contains two lists, one for each side of the market.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Depth
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeDepthV1: function (inlineObject2, options) {
            return localVarFp.marketdataSubscribeDepthV1(inlineObject2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Subscribe quote updates for a list of symbols at a maximum rate defined by interval (default is 1 second). Every message contains all fields. A maximum of up to 200 quotes can be subscribed.
         * @summary Marketdata WSS endpoint to subscribe to Market Data Quotes
         * @param {QuoteSubscribeRequestWrapper} quoteSubscribeRequestWrapper
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketdataSubscribeQuoteV1: function (quoteSubscribeRequestWrapper, options) {
            return localVarFp.marketdataSubscribeQuoteV1(quoteSubscribeRequestWrapper, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MarketdataApiFactory = MarketdataApiFactory;
/**
 * MarketdataApi - object-oriented interface
 * @export
 * @class MarketdataApi
 * @extends {BaseAPI}
 */
var MarketdataApi = /** @class */ (function (_super) {
    __extends(MarketdataApi, _super);
    function MarketdataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Refresh token
     * @summary Marketdata WSS endpoint. Allows a user to refresh the token before the accessToken expires. Returns a JWT accessToken in the response.
     * @param {InlineObject} inlineObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketdataApi
     */
    MarketdataApi.prototype.marketdataRefreshTokenV1 = function (inlineObject, options) {
        var _this = this;
        return (0, exports.MarketdataApiFp)(this.configuration).marketdataRefreshTokenV1(inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get chart data for Candlestick/Kline over a time-interval for a particular symbol
     * @summary Marketdata WSS endpoint to retrieve chart data
     * @param {InlineObject3} inlineObject3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketdataApi
     */
    MarketdataApi.prototype.marketdataSubscribeChartV1 = function (inlineObject3, options) {
        var _this = this;
        return (0, exports.MarketdataApiFp)(this.configuration).marketdataSubscribeChartV1(inlineObject3, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Subscribe to executed course of sales.
     * @summary Marketdata WSS endpoint to subscribe to Market Data Course Of Sales
     * @param {InlineObject1} inlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketdataApi
     */
    MarketdataApi.prototype.marketdataSubscribeCourseOfSaleV1 = function (inlineObject1, options) {
        var _this = this;
        return (0, exports.MarketdataApiFp)(this.configuration).marketdataSubscribeCourseOfSaleV1(inlineObject1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Market Data Depth.  Depth response is the container for the overall response. It contains two lists, one for each side of the market.
     * @summary Marketdata WSS endpoint to subscribe to Market Data Depth
     * @param {InlineObject2} inlineObject2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketdataApi
     */
    MarketdataApi.prototype.marketdataSubscribeDepthV1 = function (inlineObject2, options) {
        var _this = this;
        return (0, exports.MarketdataApiFp)(this.configuration).marketdataSubscribeDepthV1(inlineObject2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Subscribe quote updates for a list of symbols at a maximum rate defined by interval (default is 1 second). Every message contains all fields. A maximum of up to 200 quotes can be subscribed.
     * @summary Marketdata WSS endpoint to subscribe to Market Data Quotes
     * @param {QuoteSubscribeRequestWrapper} quoteSubscribeRequestWrapper
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketdataApi
     */
    MarketdataApi.prototype.marketdataSubscribeQuoteV1 = function (quoteSubscribeRequestWrapper, options) {
        var _this = this;
        return (0, exports.MarketdataApiFp)(this.configuration).marketdataSubscribeQuoteV1(quoteSubscribeRequestWrapper, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MarketdataApi;
}(base_1.BaseAPI));
exports.MarketdataApi = MarketdataApi;
/**
 * PrivateApi - axios parameter creator
 * @export
 */
var PrivateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Internal service, not exposed via the API GW. Registers a user in Braze by using the Braze API.
         * @summary Registers a user in Braze by using the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBrazeUser: function (emailServiceMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'emailServiceMessage' is not null or undefined
                    (0, common_1.assertParamExists)('registerBrazeUser', 'emailServiceMessage', emailServiceMessage);
                    localVarPath = "/private/sqs/register-braze-user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(emailServiceMessage, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Internal service, not exposed via the API GW. Sends emails to the Braze API.
         * @summary Sends emails via the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: function (emailServiceMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'emailServiceMessage' is not null or undefined
                    (0, common_1.assertParamExists)('sendEmail', 'emailServiceMessage', emailServiceMessage);
                    localVarPath = "/private/sqs/send-email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(emailServiceMessage, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.PrivateApiAxiosParamCreator = PrivateApiAxiosParamCreator;
/**
 * PrivateApi - functional programming interface
 * @export
 */
var PrivateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PrivateApiAxiosParamCreator)(configuration);
    return {
        /**
         * Internal service, not exposed via the API GW. Registers a user in Braze by using the Braze API.
         * @summary Registers a user in Braze by using the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBrazeUser: function (emailServiceMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registerBrazeUser(emailServiceMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Internal service, not exposed via the API GW. Sends emails to the Braze API.
         * @summary Sends emails via the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: function (emailServiceMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendEmail(emailServiceMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PrivateApiFp = PrivateApiFp;
/**
 * PrivateApi - factory interface
 * @export
 */
var PrivateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PrivateApiFp)(configuration);
    return {
        /**
         * Internal service, not exposed via the API GW. Registers a user in Braze by using the Braze API.
         * @summary Registers a user in Braze by using the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBrazeUser: function (emailServiceMessage, options) {
            return localVarFp.registerBrazeUser(emailServiceMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Internal service, not exposed via the API GW. Sends emails to the Braze API.
         * @summary Sends emails via the Braze API.
         * @param {EmailServiceMessage} emailServiceMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: function (emailServiceMessage, options) {
            return localVarFp.sendEmail(emailServiceMessage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PrivateApiFactory = PrivateApiFactory;
/**
 * PrivateApi - object-oriented interface
 * @export
 * @class PrivateApi
 * @extends {BaseAPI}
 */
var PrivateApi = /** @class */ (function (_super) {
    __extends(PrivateApi, _super);
    function PrivateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Internal service, not exposed via the API GW. Registers a user in Braze by using the Braze API.
     * @summary Registers a user in Braze by using the Braze API.
     * @param {EmailServiceMessage} emailServiceMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.registerBrazeUser = function (emailServiceMessage, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).registerBrazeUser(emailServiceMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Internal service, not exposed via the API GW. Sends emails to the Braze API.
     * @summary Sends emails via the Braze API.
     * @param {EmailServiceMessage} emailServiceMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateApi
     */
    PrivateApi.prototype.sendEmail = function (emailServiceMessage, options) {
        var _this = this;
        return (0, exports.PrivateApiFp)(this.configuration).sendEmail(emailServiceMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PrivateApi;
}(base_1.BaseAPI));
exports.PrivateApi = PrivateApi;
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
var SubscriptionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create or update subscription.
         * @summary Create or update subscription.
         * @param {CreateSubscriptionsRequest} createSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubscriptionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'createSubscriptionsRequest' is not null or undefined
                    (0, common_1.assertParamExists)('create', 'createSubscriptionsRequest', createSubscriptionsRequest);
                    localVarPath = "/subscriptions/create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSubscriptionsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get subscription.
         * @summary Get subscription.
         * @param {GetSubscriptionsRequest} getSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (getSubscriptionsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'getSubscriptionsRequest' is not null or undefined
                    (0, common_1.assertParamExists)('retrieve', 'getSubscriptionsRequest', getSubscriptionsRequest);
                    localVarPath = "/subscriptions/retrieve";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getSubscriptionsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.SubscriptionsApiAxiosParamCreator = SubscriptionsApiAxiosParamCreator;
/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
var SubscriptionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubscriptionsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create or update subscription.
         * @summary Create or update subscription.
         * @param {CreateSubscriptionsRequest} createSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubscriptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.create(createSubscriptionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get subscription.
         * @summary Get subscription.
         * @param {GetSubscriptionsRequest} getSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (getSubscriptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieve(getSubscriptionsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
/**
 * SubscriptionsApi - factory interface
 * @export
 */
var SubscriptionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubscriptionsApiFp)(configuration);
    return {
        /**
         * Create or update subscription.
         * @summary Create or update subscription.
         * @param {CreateSubscriptionsRequest} createSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: function (createSubscriptionsRequest, options) {
            return localVarFp.create(createSubscriptionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get subscription.
         * @summary Get subscription.
         * @param {GetSubscriptionsRequest} getSubscriptionsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieve: function (getSubscriptionsRequest, options) {
            return localVarFp.retrieve(getSubscriptionsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
var SubscriptionsApi = /** @class */ (function (_super) {
    __extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create or update subscription.
     * @summary Create or update subscription.
     * @param {CreateSubscriptionsRequest} createSubscriptionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.create = function (createSubscriptionsRequest, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).create(createSubscriptionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get subscription.
     * @summary Get subscription.
     * @param {GetSubscriptionsRequest} getSubscriptionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    SubscriptionsApi.prototype.retrieve = function (getSubscriptionsRequest, options) {
        var _this = this;
        return (0, exports.SubscriptionsApiFp)(this.configuration).retrieve(getSubscriptionsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubscriptionsApi;
}(base_1.BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
/**
 * TradingAccountApi - axios parameter creator
 * @export
 */
var TradingAccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * retrieve cash account details
         * @summary get cash account details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashAccountDetails: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/trading-account/cash-account";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TradingAccountApiAxiosParamCreator = TradingAccountApiAxiosParamCreator;
/**
 * TradingAccountApi - functional programming interface
 * @export
 */
var TradingAccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TradingAccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * retrieve cash account details
         * @summary get cash account details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashAccountDetails: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cashAccountDetails(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TradingAccountApiFp = TradingAccountApiFp;
/**
 * TradingAccountApi - factory interface
 * @export
 */
var TradingAccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TradingAccountApiFp)(configuration);
    return {
        /**
         * retrieve cash account details
         * @summary get cash account details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashAccountDetails: function (options) {
            return localVarFp.cashAccountDetails(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TradingAccountApiFactory = TradingAccountApiFactory;
/**
 * TradingAccountApi - object-oriented interface
 * @export
 * @class TradingAccountApi
 * @extends {BaseAPI}
 */
var TradingAccountApi = /** @class */ (function (_super) {
    __extends(TradingAccountApi, _super);
    function TradingAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * retrieve cash account details
     * @summary get cash account details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradingAccountApi
     */
    TradingAccountApi.prototype.cashAccountDetails = function (options) {
        var _this = this;
        return (0, exports.TradingAccountApiFp)(this.configuration).cashAccountDetails(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TradingAccountApi;
}(base_1.BaseAPI));
exports.TradingAccountApi = TradingAccountApi;
/**
 * UsersApi - axios parameter creator
 * @export
 */
var UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Gets access rights for authenticated user
         * @summary Gets access rights for authenticated user
         * @param {AccessRightsRequest} accessRightsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRights: function (accessRightsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'accessRightsRequest' is not null or undefined
                    (0, common_1.assertParamExists)('accessRights', 'accessRightsRequest', accessRightsRequest);
                    localVarPath = "/users/access-rights";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessRightsRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Verify new user email  - Verify user email by verification code  - Invokes AWS Cognito to confirm a new user
         * @summary Confirm verification code that sent to user email
         * @param {SignUpConfirmRequest} signUpConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUp: function (signUpConfirmRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'signUpConfirmRequest' is not null or undefined
                    (0, common_1.assertParamExists)('confirmSignUp', 'signUpConfirmRequest', signUpConfirmRequest);
                    localVarPath = "/users/confirm-signup";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signUpConfirmRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Forgot password
         * @summary This triggers an email to the user with a password verification code.
         * @param {ForgotPasswordRequest} forgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'forgotPasswordRequest' is not null or undefined
                    (0, common_1.assertParamExists)('forgotPassword', 'forgotPasswordRequest', forgotPasswordRequest);
                    localVarPath = "/users/forgot-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(forgotPasswordRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Forgot password submit
         * @summary Allows a user to reset their password by providing the verification code - which was sent by /forgot-password - and the updated password.
         * @param {ForgotPasswordSubmitRequest} forgotPasswordSubmitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordSubmit: function (forgotPasswordSubmitRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'forgotPasswordSubmitRequest' is not null or undefined
                    (0, common_1.assertParamExists)('forgotPasswordSubmit', 'forgotPasswordSubmitRequest', forgotPasswordSubmitRequest);
                    localVarPath = "/users/forgot-password-submit";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(forgotPasswordSubmitRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Heartbeat service
         * @summary Verifies session is still active
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeat: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    (0, common_1.assertParamExists)('heartbeat', 'body', body);
                    localVarPath = "/users/heartbeat";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Confirms promo code is available  - Confirms via promo code
         * @summary Confirm promo code is available.
         * @param {string} promoCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodeValidation: function (promoCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'promoCode' is not null or undefined
                    (0, common_1.assertParamExists)('promoCodeValidation', 'promoCode', promoCode);
                    localVarPath = "/users/promo-code-validation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (promoCode !== undefined) {
                        localVarQueryParameter['promoCode'] = promoCode;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Resend Confirmation Code
         * @summary Resend Confirmation Code
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCode: function (resendConfirmationCodeRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'resendConfirmationCodeRequest' is not null or undefined
                    (0, common_1.assertParamExists)('resendConfirmationCode', 'resendConfirmationCodeRequest', resendConfirmationCodeRequest);
                    localVarPath = "/users/resend-confirmation-code";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resendConfirmationCodeRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Gets brand for user  - Confirms via username
         * @summary Gets brand for user
         * @param {RetrieveBrandRequest} retrieveBrandRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBrand: function (retrieveBrandRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'retrieveBrandRequest' is not null or undefined
                    (0, common_1.assertParamExists)('retrieveBrand', 'retrieveBrandRequest', retrieveBrandRequest);
                    localVarPath = "/users/get-brand";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retrieveBrandRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Sign in
         * @summary Allows a user to sign in. Returns a JWT both as cookie and in the response.
         * @param {SignInRequest} signInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: function (signInRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'signInRequest' is not null or undefined
                    (0, common_1.assertParamExists)('signIn', 'signInRequest', signInRequest);
                    localVarPath = "/users/sign-in";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signInRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Sign out user
         * @summary Sign out user
         * @param {SignOutRequest} signOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: function (signOutRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'signOutRequest' is not null or undefined
                    (0, common_1.assertParamExists)('signOut', 'signOutRequest', signOutRequest);
                    localVarPath = "/users/sign-out";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signOutRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create new User  - Register new user at Braze and Cognito  - Send verification code to user email
         * @summary Create User SignUp
         * @param {SignUpRequest} signUpRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'signUpRequest' is not null or undefined
                    (0, common_1.assertParamExists)('signUp', 'signUpRequest', signUpRequest);
                    localVarPath = "/users/sign-up";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signUpRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Confirms username is available  - Confirms via username  - Checks LogonCode does not already exist in AwcData
         * @summary Confirm username is available.
         * @param {UsernameAvailableRequest} usernameAvailableRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameAvailable: function (usernameAvailableRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'usernameAvailableRequest' is not null or undefined
                    (0, common_1.assertParamExists)('usernameAvailable', 'usernameAvailableRequest', usernameAvailableRequest);
                    localVarPath = "/users/username-available";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usernameAvailableRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Verify identification and fraudulence
         * @param {VerifyIdentityRequest} verifyIdentityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerifyIdentity: function (verifyIdentityRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'verifyIdentityRequest' is not null or undefined
                            (0, common_1.assertParamExists)('usersVerifyIdentity', 'verifyIdentityRequest', verifyIdentityRequest);
                            localVarPath = "/users/verify-identity";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication cmc required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc", [], configuration)
                                // authentication cmc-nonprod required
                                // oauth required
                            ];
                        case 1:
                            // authentication cmc required
                            // oauth required
                            _a.sent();
                            // authentication cmc-nonprod required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "cmc-nonprod", [], configuration)];
                        case 2:
                            // authentication cmc-nonprod required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyIdentityRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
var UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UsersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gets access rights for authenticated user
         * @summary Gets access rights for authenticated user
         * @param {AccessRightsRequest} accessRightsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRights: function (accessRightsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.accessRights(accessRightsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verify new user email  - Verify user email by verification code  - Invokes AWS Cognito to confirm a new user
         * @summary Confirm verification code that sent to user email
         * @param {SignUpConfirmRequest} signUpConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUp: function (signUpConfirmRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.confirmSignUp(signUpConfirmRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Forgot password
         * @summary This triggers an email to the user with a password verification code.
         * @param {ForgotPasswordRequest} forgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.forgotPassword(forgotPasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Forgot password submit
         * @summary Allows a user to reset their password by providing the verification code - which was sent by /forgot-password - and the updated password.
         * @param {ForgotPasswordSubmitRequest} forgotPasswordSubmitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordSubmit: function (forgotPasswordSubmitRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.forgotPasswordSubmit(forgotPasswordSubmitRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Heartbeat service
         * @summary Verifies session is still active
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeat: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.heartbeat(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Confirms promo code is available  - Confirms via promo code
         * @summary Confirm promo code is available.
         * @param {string} promoCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodeValidation: function (promoCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.promoCodeValidation(promoCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Resend Confirmation Code
         * @summary Resend Confirmation Code
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCode: function (resendConfirmationCodeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resendConfirmationCode(resendConfirmationCodeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Gets brand for user  - Confirms via username
         * @summary Gets brand for user
         * @param {RetrieveBrandRequest} retrieveBrandRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBrand: function (retrieveBrandRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retrieveBrand(retrieveBrandRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sign in
         * @summary Allows a user to sign in. Returns a JWT both as cookie and in the response.
         * @param {SignInRequest} signInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: function (signInRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signIn(signInRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sign out user
         * @summary Sign out user
         * @param {SignOutRequest} signOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: function (signOutRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signOut(signOutRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create new User  - Register new user at Braze and Cognito  - Send verification code to user email
         * @summary Create User SignUp
         * @param {SignUpRequest} signUpRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.signUp(signUpRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Confirms username is available  - Confirms via username  - Checks LogonCode does not already exist in AwcData
         * @summary Confirm username is available.
         * @param {UsernameAvailableRequest} usernameAvailableRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameAvailable: function (usernameAvailableRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usernameAvailable(usernameAvailableRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Verify identification and fraudulence
         * @param {VerifyIdentityRequest} verifyIdentityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerifyIdentity: function (verifyIdentityRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersVerifyIdentity(verifyIdentityRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
var UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UsersApiFp)(configuration);
    return {
        /**
         * Gets access rights for authenticated user
         * @summary Gets access rights for authenticated user
         * @param {AccessRightsRequest} accessRightsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRights: function (accessRightsRequest, options) {
            return localVarFp.accessRights(accessRightsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verify new user email  - Verify user email by verification code  - Invokes AWS Cognito to confirm a new user
         * @summary Confirm verification code that sent to user email
         * @param {SignUpConfirmRequest} signUpConfirmRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSignUp: function (signUpConfirmRequest, options) {
            return localVarFp.confirmSignUp(signUpConfirmRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Forgot password
         * @summary This triggers an email to the user with a password verification code.
         * @param {ForgotPasswordRequest} forgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: function (forgotPasswordRequest, options) {
            return localVarFp.forgotPassword(forgotPasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Forgot password submit
         * @summary Allows a user to reset their password by providing the verification code - which was sent by /forgot-password - and the updated password.
         * @param {ForgotPasswordSubmitRequest} forgotPasswordSubmitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordSubmit: function (forgotPasswordSubmitRequest, options) {
            return localVarFp.forgotPasswordSubmit(forgotPasswordSubmitRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Heartbeat service
         * @summary Verifies session is still active
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeat: function (body, options) {
            return localVarFp.heartbeat(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Confirms promo code is available  - Confirms via promo code
         * @summary Confirm promo code is available.
         * @param {string} promoCode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodeValidation: function (promoCode, options) {
            return localVarFp.promoCodeValidation(promoCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Resend Confirmation Code
         * @summary Resend Confirmation Code
         * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationCode: function (resendConfirmationCodeRequest, options) {
            return localVarFp.resendConfirmationCode(resendConfirmationCodeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets brand for user  - Confirms via username
         * @summary Gets brand for user
         * @param {RetrieveBrandRequest} retrieveBrandRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBrand: function (retrieveBrandRequest, options) {
            return localVarFp.retrieveBrand(retrieveBrandRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sign in
         * @summary Allows a user to sign in. Returns a JWT both as cookie and in the response.
         * @param {SignInRequest} signInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: function (signInRequest, options) {
            return localVarFp.signIn(signInRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sign out user
         * @summary Sign out user
         * @param {SignOutRequest} signOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOut: function (signOutRequest, options) {
            return localVarFp.signOut(signOutRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create new User  - Register new user at Braze and Cognito  - Send verification code to user email
         * @summary Create User SignUp
         * @param {SignUpRequest} signUpRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: function (signUpRequest, options) {
            return localVarFp.signUp(signUpRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Confirms username is available  - Confirms via username  - Checks LogonCode does not already exist in AwcData
         * @summary Confirm username is available.
         * @param {UsernameAvailableRequest} usernameAvailableRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usernameAvailable: function (usernameAvailableRequest, options) {
            return localVarFp.usernameAvailable(usernameAvailableRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Verify identification and fraudulence
         * @param {VerifyIdentityRequest} verifyIdentityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerifyIdentity: function (verifyIdentityRequest, options) {
            return localVarFp.usersVerifyIdentity(verifyIdentityRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets access rights for authenticated user
     * @summary Gets access rights for authenticated user
     * @param {AccessRightsRequest} accessRightsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.accessRights = function (accessRightsRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).accessRights(accessRightsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verify new user email  - Verify user email by verification code  - Invokes AWS Cognito to confirm a new user
     * @summary Confirm verification code that sent to user email
     * @param {SignUpConfirmRequest} signUpConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.confirmSignUp = function (signUpConfirmRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).confirmSignUp(signUpConfirmRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Forgot password
     * @summary This triggers an email to the user with a password verification code.
     * @param {ForgotPasswordRequest} forgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.forgotPassword = function (forgotPasswordRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).forgotPassword(forgotPasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Forgot password submit
     * @summary Allows a user to reset their password by providing the verification code - which was sent by /forgot-password - and the updated password.
     * @param {ForgotPasswordSubmitRequest} forgotPasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.forgotPasswordSubmit = function (forgotPasswordSubmitRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).forgotPasswordSubmit(forgotPasswordSubmitRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Heartbeat service
     * @summary Verifies session is still active
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.heartbeat = function (body, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).heartbeat(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Confirms promo code is available  - Confirms via promo code
     * @summary Confirm promo code is available.
     * @param {string} promoCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.promoCodeValidation = function (promoCode, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).promoCodeValidation(promoCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Resend Confirmation Code
     * @summary Resend Confirmation Code
     * @param {ResendConfirmationCodeRequest} resendConfirmationCodeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.resendConfirmationCode = function (resendConfirmationCodeRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).resendConfirmationCode(resendConfirmationCodeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets brand for user  - Confirms via username
     * @summary Gets brand for user
     * @param {RetrieveBrandRequest} retrieveBrandRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.retrieveBrand = function (retrieveBrandRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).retrieveBrand(retrieveBrandRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sign in
     * @summary Allows a user to sign in. Returns a JWT both as cookie and in the response.
     * @param {SignInRequest} signInRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.signIn = function (signInRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).signIn(signInRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sign out user
     * @summary Sign out user
     * @param {SignOutRequest} signOutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.signOut = function (signOutRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).signOut(signOutRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create new User  - Register new user at Braze and Cognito  - Send verification code to user email
     * @summary Create User SignUp
     * @param {SignUpRequest} signUpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.signUp = function (signUpRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).signUp(signUpRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Confirms username is available  - Confirms via username  - Checks LogonCode does not already exist in AwcData
     * @summary Confirm username is available.
     * @param {UsernameAvailableRequest} usernameAvailableRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.usernameAvailable = function (usernameAvailableRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).usernameAvailable(usernameAvailableRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Verify identification and fraudulence
     * @param {VerifyIdentityRequest} verifyIdentityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.usersVerifyIdentity = function (verifyIdentityRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).usersVerifyIdentity(verifyIdentityRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
